// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/BsComBtnBorder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/BsHoverLeft.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/BsHoverRight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/yellow-border-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/ReadmoreBorderBottom.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/WhoWEAreNewBGDarkNew.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/NewBGLightBS.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/newsletterBSborder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/inputBorderBs.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/GuppyStoriesBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images/NewBorderH4Backstage.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images/BsNewDarkBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images/NewLightBSBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images/NewInputBorder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/images/new.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/images/SeeMoreBtnYellowBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../assets/images/mobileTeamDarkBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../assets/images/mobileTeamLightBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../assets/images/MobileleftHover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../assets/images/MobilerightHover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../assets/images/OurTeamDarkBgBlue.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO a span,
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuSubLi__\\+JeiS a,
.Backstagelandingpage_TeamHyperLink__fZURU {
  text-decoration-line: underline;
}
.Backstagelandingpage_BsComBtn__IHULv,
.Backstagelandingpage_BsComYellowBtn__nv6wY {
  border-style: solid;
  cursor: pointer;
}
.Backstagelandingpage_BsComBtn__IHULv {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  font-family: Kodchasan, sans-serif;
  color: #fff;
  background: #0d5268;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 8px;
  border-image-outset: 8px;
  padding: 5px 20px;
}
.Backstagelandingpage_BsH1__T6mc9,
.Backstagelandingpage_BsH2__pgYpZ {
  font-weight: 700;
  color: #000;
  text-align: center;
  font-family: "Cabin Sketch", cursive;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6,
.Backstagelandingpage_WrapperIpInside__h\\+nE0,
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_WTGBSection__kTe6v,
.Backstagelandingpage_WrapperMain__oLyIf,
.Backstagelandingpage_WrapperOurTeam__JW5qZ {
  background: #e4f2ff;
}
.Backstagelandingpage_Row__gfnt4 {
  align-items: center;
}
.Backstagelandingpage_BsH1__T6mc9 {
  font-size: 96px;
  line-height: 112px;
}
.Backstagelandingpage_BsH2__pgYpZ {
  font-size: 72px;
  line-height: 84px;
  margin-bottom: 40px;
}
.Backstagelandingpage_BsH3__KKWUT,
.Backstagelandingpage_BsH4__5Dg3m {
  margin-bottom: 30px;
  color: #000;
  font-weight: 700;
}
.Backstagelandingpage_BsH3__KKWUT {
  font-size: 56px;
  line-height: 66px;
  font-family: "Cabin Sketch", cursive;
}
.Backstagelandingpage_BsH4__5Dg3m,
.Backstagelandingpage_DropDownButtonChild__LGQij {
  font-family: Kodchasan, sans-serif;
}
.Backstagelandingpage_BsH4__5Dg3m {
  font-size: 48px;
  line-height: 62px;
  text-align: left;
}
.Backstagelandingpage_BsCommaonP__GE0Hn {
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.02em;
  color: #000;
}
.Backstagelandingpage_BsCommaonPS__nOJP0 {
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.02em;
  font-weight: bold;
  color: #000;
}
.Backstagelandingpage_BsCommaonPM__59mZC {
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0.02em;
  font-weight: bold;
  color: #000;
}
.Backstagelandingpage_TeamHyperLink__fZURU {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  margin-top: 40px;
  display: block;
  margin-left: 5px;
}
.Backstagelandingpage_navheaderBackstage__9p2NY {
  padding-top: 20px;
}
.Backstagelandingpage_navheaderBackstage__9p2NY .Backstagelandingpage_navheaderBgImg__JIePU {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
}
.Backstagelandingpage_navheaderBackstage__9p2NY .Backstagelandingpage_MainHeadingHead__Mpbn\\+ {
  font-weight: 700;
  font-size: 68px;
  line-height: 80px;
  color: #e4f2ff;
}
.Backstagelandingpage_WrapperContactBackstage__V-Mv3,
.Backstagelandingpage_WrapperTemplatePage__p9CWA,
.Backstagelandingpage_WrapperWhatWeSell__w4S7y,
.Backstagelandingpage_WrapperWhoWeAre__7UPpF {
  background-color: #e4f2ff;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 {
  padding-top: 100px;
  min-height: 100vh;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuLi__SEL2V {
  background: #56cdd5;
  border-radius: 14px;
  text-align: left;
  padding: 10px 30px;
  margin-bottom: 24px;
  width: 43%;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuLi__SEL2V a {
  color: #000;
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuSubLi__\\+JeiS {
  width: 35%;
  display: inline-block;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuBottom__woCpn p {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #0d5268;
  margin-bottom: 15px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuBottom__woCpn .Backstagelandingpage_SocialIconMenu__8JHy8 img {
  width: 47px;
  height: 45px;
  margin-right: 18px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuBottom__woCpn {
  margin-top: 50px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB li {
  list-style-type: disc;
  margin-bottom: 20px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB li a {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #000;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB li:hover a {
  color: #0d5268;
  text-decoration: underline;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
  position: absolute;
  right: 300px;
  top: 0;
  display: none;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
  display: block;
  z-index: 1;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T {
  position: relative;
  cursor: pointer;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:nth-child(2) .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
  top: -85px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:first-child .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
  right: 220px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover .Backstagelandingpage_BackstageMenuSubLi__\\+JeiS {
  background-color: #0d5268;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover .Backstagelandingpage_BackstageMenuSubLi__\\+JeiS a {
  color: #d9eb41;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover .Backstagelandingpage_BackstageMenuMainNavimg__SByLy,
.Backstagelandingpage_BackstageMenuMainNavHover__Ajz1W,
.Backstagelandingpage_CopyrightTextNewMobile__Ib3yh,
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe:hover .Backstagelandingpage_currentIpsLogo__ofB2v,
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe:hover .Backstagelandingpage_currentIpsNew__lHWGU,
.Backstagelandingpage_DropDownButtonNew__KqAsa button:hover::before,
.Backstagelandingpage_MobileIntroducingImgNew__-zkqx,
.Backstagelandingpage_MobileMaharajaImageNew__PDwYm,
.Backstagelandingpage_WTGBSectionLeft__CbXmj .Backstagelandingpage_ImageBottomInfoSpan__qxCA0,
.Backstagelandingpage_WrapperWhatWeSell__w4S7y
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
  .Backstagelandingpage_GuppyStoriesBackstageSectionTop__wmes2,
.Backstagelandingpage_WrapperWhatWeSell__w4S7y .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 h2 {
  display: none;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover:before {
  content: "";
  position: absolute;
  top: 0;
  left: -40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  width: 28px;
  height: 65px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover:after {
  content: "";
  position: absolute;
  top: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  width: 36px;
  height: 69px;
}
.Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover .Backstagelandingpage_BackstageMenuMainNavHover__Ajz1W {
  display: inline-block;
}
.Backstagelandingpage_navbarInnerInfo__NPMxs {
  z-index: 2;
}
.Backstagelandingpage_navheaderBackstageNew__KJ4Fe {
  position: sticky;
  z-index: 2;
  top: 0;
}
.Backstagelandingpage_navheaderBackstageNew__KJ4Fe .Backstagelandingpage_navheaderMainInner__\\+507B {
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 25px;
  width: 100%;
}
.Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z table,
.Backstagelandingpage_WhoWeAreSectionNewBottomCutImg__aIRJd,
.Backstagelandingpage_WrapperGuppyIntro__Njw19 .Backstagelandingpage_TeamDarkBCGroung__xTYxT img,
.Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WhoWeAreSectionNewBottomCutImg__aIRJd,
.Backstagelandingpage_navheaderBackstageNew__KJ4Fe .Backstagelandingpage_navheaderBgImg__JIePU {
  width: 100%;
}
.Backstagelandingpage_BsComYellowBtn__nv6wY {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 8px;
  border-image-outset: 8px;
  padding: 5px 20px;
  background: #d9eb41;
}
.Backstagelandingpage_bannerSlider__us3k0 .Backstagelandingpage_bannerSliderBtn__2KGef {
  position: absolute;
  bottom: 95px;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  display: inline-block;
  width: max-content;
}
.Backstagelandingpage_WTGBSection__kTe6v {
  padding: 60px;
}
.Backstagelandingpage_ReadMoreCmn__tCmlt {
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
  text-align: center;
  color: #0d5268;
  cursor: pointer;
  border: 0;
  background: 0 0;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki,
.Backstagelandingpage_WhoWeAreSection__sBp4Q {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.Backstagelandingpage_ReadMoreCmn__tCmlt img {
  width: 52px;
}
.Backstagelandingpage_ReadMoreCmn__tCmlt span {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 0 0 12px 0;
  border-image-outset: 0 0 8px 0;
  border-style: solid;
  display: inline-block;
  margin-right: 15px;
}
.Backstagelandingpage_WhoWeAreSection__sBp4Q {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  padding: 120px 60px;
  margin-top: -75px;
}
.Backstagelandingpage_WrapperMain__oLyIf .Backstagelandingpage_WhoWeAreSection__sBp4Q {
  margin-top: -10px;
}
.Backstagelandingpage_WhoWeAreSection__sBp4Q p,
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSectionLeft__CbXmj p {
  margin-bottom: 45px;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  padding: 60px 0 0;
  margin-top: -55px;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe {
  position: relative;
  padding: 10px;
  cursor: pointer;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_ipsBackImg__8tOVO {
  filter: blur(10px);
  -webkit-filter: blur(10px);
  width: 100%;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe:hover .Backstagelandingpage_ipsBackImg__8tOVO {
  filter: blur(0px);
  -webkit-filter: blur(0px);
  width: 100%;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_currentIpsLogo__ofB2v {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 180px;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe:nth-child(3) .Backstagelandingpage_currentIpsLogo__ofB2v {
  width: 310px;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe:hover .Backstagelandingpage_SeeMoreBtn__E6xir {
  visibility: visible;
  cursor: pointer;
}
.Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_currentIpsNew__lHWGU {
  position: absolute;
  top: 30px;
  right: 45px;
  width: 80px;
}
.Backstagelandingpage_NewsletterSection__QI\\+5\\+ {
  padding: 80px 0;
  text-align: center;
}
.Backstagelandingpage_NewsletterInner__n7WiP {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  filter: drop-shadow(-12px -12px 24px rgba(91, 91, 91, 0.1));
  background: #b3e8ec;
  padding: 32px 0;
  width: 85%;
  margin: auto;
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 10px;
  border-image-outset: 0 5px;
  cursor: pointer;
  border-style: solid;
}
.Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP h3 {
  margin-bottom: 16px;
  font-size: 48px;
  line-height: 56px;
}
.Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP p {
  margin-bottom: 36px;
  font-size: 18px;
  line-height: 26px;
}
.Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP .Backstagelandingpage_emailInput__bbAkb {
  width: 35%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 8px;
  cursor: pointer;
  border-style: solid;
}
.Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP .Backstagelandingpage_emailInput__bbAkb input {
  padding: 13px 20px;
  border: 0;
  background-color: transparent;
  width: 90%;
}
.Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP .Backstagelandingpage_emailInput__bbAkb input:focus {
  outline: 0;
  border: 0;
}
.Backstagelandingpage_NewsSection__ntpF- {
  text-align: center;
  padding-bottom: 60px;
}
.Backstagelandingpage_NewsSection__ntpF- h2,
.Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WTGBSection__kTe6v h1 {
  margin-bottom: 30px;
}
.Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageRight__Jc6tG p,
.Backstagelandingpage_NewsSection__ntpF- p.Backstagelandingpage_BsCommaonP__GE0Hn {
  margin-bottom: 50px;
}
.Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 120px 60px 60px;
}
.Backstagelandingpage_FooterBackstage__HSsC1,
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSection__kTe6v {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
}
.Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageSectionBottom__jnGjp {
  margin-top: 72px;
}
.Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p h3 {
  font-weight: 700;
  font-size: 42px;
  line-height: 59px;
  color: #000;
  font-family: "Cabin Sketch", cursive;
  margin-bottom: 36px;
}
.Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
  .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p
  .Backstagelandingpage_GuppyStoriesBackstageSoicalMain__SHP\\+j
  span {
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  margin-bottom: 36px;
  color: #000;
  display: block;
}
.Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
  .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p
  .Backstagelandingpage_GuppyStoriesBackstageSoicalMain__SHP\\+j
  a
  img {
  margin-right: 25px;
}
.Backstagelandingpage_FooterBackstage__HSsC1 {
  background-size: 100% 100%;
  padding-top: 80px;
  margin-top: -125px;
  position: relative;
}
.Backstagelandingpage_FooterBackstage__HSsC1 .Backstagelandingpage_emailInputBackstage__ec4Rd {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 8px;
  cursor: pointer;
  border-style: solid;
  position: relative;
  display: inline-block;
}
.Backstagelandingpage_FooterBackstage__HSsC1 .Backstagelandingpage_emailInputBackstage__ec4Rd input {
  background-color: transparent;
}
.Backstagelandingpage_BannerCommon__QhnJj,
.Backstagelandingpage_CopyrightTextNew__zN1j0,
.Backstagelandingpage_mainRel__9Egqz {
  position: relative;
}
.Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_BackBtnBSCommonNew__B5Ati {
  position: absolute;
  top: 75px;
  left: 130px;
}
.Backstagelandingpage_BannerCommonImg__HNDYC {
  width: 100%;
  height: 500px;
  object-fit: cover;
}
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSection__sBp4Q {
  margin-top: -72px;
  position: relative;
  padding: 75px 60px;
}
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX {
  padding: 0;
}
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_bottomNewWhoWeare__Fykbk {
  padding: 0 60px 175px;
}
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSection__kTe6v {
  background-size: contain;
  margin-top: -65px;
  padding: 120px 60px;
  position: relative;
}
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_Row__gfnt4 {
  margin-bottom: 80px;
}
.Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX {
  padding: 0 0 120px;
  margin-top: 0;
}
.Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX h2 {
  margin: 36px 0;
}
.Backstagelandingpage_WhoWeAreRightNew__NN1nW,
.Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_WhoWeAreRight__kG1P5 p {
  text-align: center;
  margin-bottom: 50px;
}
.Backstagelandingpage_TeamDarkBCGroung__xTYxT {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 120px 60px;
  margin-top: -90px;
  position: relative;
}
.Backstagelandingpage_TeamLightBCGroung__JogsD,
.Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WhoWeAreSectionNewTop__yFQ2y,
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4:nth-child(odd) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
}
.Backstagelandingpage_TeamLightBCGroung__JogsD {
  background-size: cover;
  padding: 120px 60px;
  margin-top: -55px;
}
.Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_BannerCommon__QhnJj {
  text-align: center;
  background-color: #e4f2ff;
  padding: 0 60px;
  height: 400px;
  display: flex;
}
.Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_BannerCommonText__Ethep {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 75%;
  margin: auto;
}
.Backstagelandingpage_TeamHyperLink__fZURU img {
  width: 50px;
  margin-right: 15px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactBsSectionTop__hqInV,
.Backstagelandingpage_GIMain__ZvQZM,
.Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_BannerCommonText__Ethep h4,
.Backstagelandingpage_WrapperWhatWeSell__w4S7y .Backstagelandingpage_WhoWeAreRight__kG1P5 p {
  text-align: center;
}
.Backstagelandingpage_GIMain__ZvQZM h1 {
  margin-bottom: 36px;
}
.Backstagelandingpage_GIMain__ZvQZM p.Backstagelandingpage_paraTop__hu9EY {
  margin-bottom: 60px;
}
.Backstagelandingpage_GIMain__ZvQZM p.Backstagelandingpage_paraBottom__FUOMo {
  margin: 36px 0 70px;
}
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WrapperWhatWeDoTop__wuaMW {
  margin-top: -68px;
  position: relative;
  padding: 70px 60px 100px;
}
.Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WTGBSectionLeft__CbXmj h4,
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 h4 {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  border-image-repeat: stretch;
  border-image-slice: 20;
  border-image-width: 0 0 12px 0;
  border-image-outset: 8px;
  border-style: solid;
  display: inline-block;
  padding-bottom: 12px;
}
.Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE,
.Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_TPBottom__VuTE3 {
  padding: 0 60px;
}
.Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_MaharajaBannerImg__6LkA- {
  width: 100%;
  margin-top: -105px;
  position: relative;
}
.Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainTop__s99xL p {
  font-style: italic;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: #000;
  margin-top: 22px;
  padding: 0 30px;
}
.Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE p {
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.02em;
  color: #000;
  margin: 36px 0 80px;
}
.Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE .Backstagelandingpage_BackStageMaharajaLeft__EQbuW h3 {
  font-style: italic;
  font-weight: 700;
  font-size: 32px;
  line-height: 45px;
  letter-spacing: 0.02em;
  color: #000;
}
.Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE .Backstagelandingpage_BackStageMaharajaRight__R6vnE p {
  font-style: italic;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: #000;
}
.Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO span {
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}
.Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO a {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #000;
  display: inline-block;
}
.Backstagelandingpage_FooterBackstage__HSsC1 .Backstagelandingpage_footerMid__LJX7J {
  padding-left: 85px;
}
.Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WhoWeAreSectionNewTop__yFQ2y {
  background-size: 100% 100%;
  padding: 60px 60px 0;
}
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 p {
  margin-bottom: 20px;
}
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 a.Backstagelandingpage_ReadMoreCmn__tCmlt span {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 0 0 8px 0;
  border-image-outset: 8px;
  border-style: solid;
}
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4:nth-child(odd) {
  background-size: 100% 100%;
  position: relative;
}
.Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz h1 {
  font-size: 68px;
  line-height: 84px;
}
.Backstagelandingpage_CreditSection__RQ6lu h5,
.Backstagelandingpage_CreditSection__RQ6lu p,
.Backstagelandingpage_ExtraParaIpinside__mBhvY h5,
.Backstagelandingpage_ExtraParaIpinside__mBhvY p {
  font-size: 21px;
  line-height: 27px;
  text-align: center;
  color: #000;
}
.Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz {
  background-color: #e4f2ff;
  padding: 35px 0;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_MaharajaBannerImg__6LkA- {
  margin-top: -70px;
}
.Backstagelandingpage_StoryInformationBackstageSection__2pK2q,
.Backstagelandingpage_WrapperNews__O2k-J {
  background: #b3e8ec;
}
.Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z {
  padding: 30px 15px;
}
.Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z h4 {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  border-image-repeat: stretch;
  border-image-slice: 20;
  border-image-width: 0 0 7px 0;
  border-image-outset: 8px;
  border-style: solid;
  width: max-content;
}
.Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z td {
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  margin-bottom: 16px;
  display: inline-block;
  width: 50%;
}
.Backstagelandingpage_StoryInformationBackstageSection__2pK2q
  .Backstagelandingpage_StoryInformationBackstageRight__M101Z
  td:first-child {
  font-weight: 700;
}
.Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z img {
  display: block;
  margin: 0 auto 30px;
  width: auto;
}
.Backstagelandingpage_ImageBottomInfoSpan__qxCA0 {
  font-style: italic;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: #000;
  display: block;
  margin-top: 15px;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_BSHyperLinkPriviousNextWrapper__RTHzq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 50px 0 100px;
  position: relative;
}
.Backstagelandingpage_ExtraParaIpinside__mBhvY {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 50px 0;
  margin-top: -40px;
  position: relative;
}
.Backstagelandingpage_ExtraParaIpinside__mBhvY p {
  font-weight: 400;
}
.Backstagelandingpage_CreditSection__RQ6lu {
  text-align: center;
  padding: 50px 0;
}
.Backstagelandingpage_CreditSection__RQ6lu h5,
.Backstagelandingpage_ExtraParaIpinside__mBhvY h5 {
  font-weight: 700;
  margin-bottom: 15px;
}
.Backstagelandingpage_CreditSection__RQ6lu p {
  font-weight: 400;
}
.Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe p {
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-family: "Cabin Sketch", cursive;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_SellProductPara__\\+ONaV {
  background: #d9eb41;
  border: 1.5px solid #000;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  align-items: center;
}
.Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_CurrentIpsSection__6Mqki {
  padding: 60px 0;
}
.Backstagelandingpage_WrapperWhatWeSell__w4S7y .Backstagelandingpage_TeamLightBCGroung__JogsD {
  position: relative;
  padding: 50px 60px;
}
.Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_SharePlusSign__YpVT0 {
  height: 100%;
}
.Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
  background-image: none;
  margin-top: 0;
  padding: 60px;
}
.Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp h4 {
  font-size: 36px;
  line-height: 50px;
  margin-bottom: 15px;
}
.Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU {
  margin: 0 0 100px;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_StoryInformationBackstageRight__M101Z .Backstagelandingpage_BsCommaonP__GE0Hn,
.Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp p {
  margin-bottom: 15px;
}
.Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp a {
  color: #000;
  display: block;
  text-align: left;
}
.Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp a span {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  border-image-repeat: stretch;
  border-image-slice: 20;
  border-image-width: 0 0 8px 0;
  border-image-outset: 8px;
  border-style: solid;
}
.Backstagelandingpage_WrapperContactBackstage__V-Mv3 .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
  margin-top: 0;
  padding: 60px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy {
  font-weight: 500;
  font-size: 28px;
  line-height: 65px;
  color: #000;
}
.Backstagelandingpage_WrapperContactBackstage__V-Mv3 .Backstagelandingpage_ContactBsSection__jeSI5 form {
  margin: 35px auto 0;
  width: 70%;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactApprovalBox__ybfzi span {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #000;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input,
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy select {
  margin-bottom: 25px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input,
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy select,
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy textarea {
  padding: 0 5px;
  font-style: italic;
  font-weight: 700;
  font-size: 28px;
  color: #0d5268;
  background: 0 0;
  border: 0;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input:focus-visible,
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy select:focus-visible,
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy textarea:focus-visible {
  outline: 0;
  border: 0;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input::placeholder,
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy textarea::placeholder {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  border-image-repeat: stretch;
  border-image-slice: 14;
  border-image-width: 0 0 8px 0;
  border-image-outset: 0;
  border-style: solid;
  padding: 0 5px;
  font-style: italic;
  font-weight: 700;
  font-size: 28px;
  line-height: 65px;
  color: rgb(13, 82, 104, 0.5);
  opacity: 1;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input[type="tel"]::placeholder {
  border: 0;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input.Backstagelandingpage_TextNameInput__5Z47d::placeholder {
  width: 180px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input.Backstagelandingpage_DropDown__l3CPf::placeholder {
  width: 400px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input.Backstagelandingpage_EmailUserInput__kYSgA::placeholder {
  width: 180px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_TextCommentInput__jD5cc::placeholder {
  width: 300px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_DropDown__l3CPf {
  width: 450px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy textarea {
  width: 100%;
  height: auto;
}
.Backstagelandingpage_ContactBsSection__jeSI5 {
  padding: 60px 60px 0;
  position: relative;
  background-size: contain;
  margin-top: -80px;
}
.Backstagelandingpage_DropDownButtonParent__MOb1k,
.Backstagelandingpage_dropdownNewContact__-UtAb {
  background: #0d5268;
  border: 4px solid #000;
  padding: 15px;
  display: flex;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactApprovalBox__ybfzi {
  margin: 50px 0;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactBsSectionBottom__m7wzK button {
  position: relative;
  width: 150px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactBsSectionBottom__m7wzK button:hover {
  background-color: transparent;
  color: #0d5268;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactBsSectionBottom__m7wzK button:focus {
  border: 0;
  outline: 0;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactBsSectionBottom__m7wzK button:hover::after {
  content: "";
  position: absolute;
  top: -8px;
  right: -55px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  width: 36px;
  height: 69px;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactBsSectionBottom__m7wzK button:hover::before {
  content: "";
  position: absolute;
  top: -5px;
  left: -40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  width: 28px;
  height: 65px;
}
.Backstagelandingpage_dropdownArrowImg__WwpF4 {
  width: 40px;
  transform: rotate(90deg);
  cursor: pointer;
}
.Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_SuccessMessage__LhB\\+b p {
  font-weight: 600;
  color: #159445;
  margin: 40px 0 0;
}
.Backstagelandingpage_dropdownNewContact__-UtAb {
  justify-content: space-between;
  align-items: center;
  width: 110%;
}
.Backstagelandingpage_dropdownNewContact__-UtAb ul {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  align-items: center;
  flex-wrap: wrap;
}
.Backstagelandingpage_dropdownNewContact__-UtAb li {
  font-weight: 600;
  font-size: 26px;
  line-height: 42px;
  color: #fff;
  margin-bottom: 15px;
  flex: 0 0 50%;
  max-width: 50%;
}
.Backstagelandingpage_dropdownNewContact__-UtAb li img {
  padding-right: 15px;
  cursor: pointer;
}
.Backstagelandingpage_DropDownButtonNew__KqAsa button {
  width: auto !important;
  text-align: center;
  padding: 0 5px;
  font-style: italic;
  font-weight: 700;
  font-size: 28px;
  line-height: 65px;
  color: #0d5268;
  background: 0 0;
  border: 0;
  position: relative;
}
.Backstagelandingpage_DropDownButtonParent__MOb1k {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.Backstagelandingpage_DropDownButtonValue__wgvX2,
.Backstagelandingpage_SeeMoreBtn__E6xir button {
  font-weight: 700;
  font-size: 28px;
  border: 0;
  text-align: center;
}
.Backstagelandingpage_DropDownButtonValue__wgvX2 {
  padding: 0 5px;
  font-style: italic;
  line-height: 65px;
  color: #000;
  background: 0 0;
}
.Backstagelandingpage_DropDownButtonChild__LGQij:hover {
  background-color: transparent;
  color: #fff;
}
.Backstagelandingpage_DropDownButtonChild__LGQij {
  font-weight: 600;
  font-size: 36px;
  line-height: 47px;
  color: #fff;
  margin-bottom: 15px;
  flex: 0 0 50%;
  max-width: 50%;
}
.Backstagelandingpage_FooterBackstage__HSsC1 .Backstagelandingpage_copyrightTextNew__weF7i {
  font-weight: 500;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  color: #000;
  margin: 50px 0 0;
}
.Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamLightBCGroung__JogsD {
  background-size: contain;
  position: relative;
  margin-top: -72px;
}
.Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_OurTeamHederTop__JoHdl {
  text-align: center;
  padding: 0 30px 80px;
  width: 80%;
  margin: auto;
}
.Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_Row__gfnt4 {
  margin-bottom: 90px;
}
.Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamInnerTextSec__Ytbxp p a {
  color: #000;
}
.Backstagelandingpage_currentIpsNew__lHWGU p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  width: 94px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.Backstagelandingpage_SeeMoreBtn__E6xir button {
  line-height: 36px;
  color: #000;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 15px 18px;
  background-color: transparent;
  cursor: pointer;
}
.Backstagelandingpage_SeeMoreBtn__E6xir {
  text-align: center;
  position: absolute;
  bottom: 72px;
  left: 0;
  right: 0;
  visibility: hidden;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_FooterBackstage__HSsC1 {
  margin-top: -55px;
}
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerTextSec__Ytbxp .Backstagelandingpage_ReadMoreCmn__tCmlt img {
  width: auto;
}
@media (min-width: 1200px) {
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 {
    margin-top: -15px;
  }
}
@media (max-width: 1199px) {
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_DropDown__l3CPf,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_EmailUserInput__kYSgA,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_NumberInput__2i8YM,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_TextCommentInput__jD5cc,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_TextNameInput__5Z47d {
    width: auto !important;
  }
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy .Backstagelandingpage_DropDown__l3CPf {
    width: 450px;
  }
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input,
  .Backstagelandingpage_dropdownNewContact__-UtAb li {
    font-size: 20px;
    line-height: 30px;
  }
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    padding: 30px;
  }
  .Backstagelandingpage_BsComBtn__IHULv,
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp h4 {
    font-size: 25px;
    line-height: 35px;
  }
  .Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz h1 {
    font-size: 50px;
    line-height: 65px;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l
    .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE
    .Backstagelandingpage_BackStageMaharajaLeft__EQbuW
    h3 {
    font-size: 25px;
    line-height: 32px;
  }
  .Backstagelandingpage_BsH1__T6mc9 {
    font-size: 58px;
    line-height: 85px;
  }
  .Backstagelandingpage_BsH4__5Dg3m {
    font-size: 40px;
    line-height: 52px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuLi__SEL2V a {
    font-size: 30px;
    line-height: 40px;
  }
  .Backstagelandingpage_navheaderBackstage__9p2NY {
    padding-top: 0;
  }
  .Backstagelandingpage_navheaderBackstage__9p2NY .Backstagelandingpage_MainHeadingHead__Mpbn\\+ {
    font-size: 54px;
    line-height: 65px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
    .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p
    .Backstagelandingpage_GuppyStoriesBackstageSoicalMain__SHP\\+j
    a
    img {
    margin-right: 10px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p h3 {
    font-size: 32px;
    line-height: 42px;
  }
  .Backstagelandingpage_BsCommaonP__GE0Hn {
    font-size: 20px;
    line-height: 28px;
  }
  .Backstagelandingpage_BsCommaonPS__nOJP0 {
    font-size: 16px;
    line-height: 28px;
  }
  .Backstagelandingpage_BsCommaonPM__59mZC {
    font-size: 14px;
    line-height: 20px;
  }
  .Backstagelandingpage_BsH2__pgYpZ {
    font-size: 60px;
    line-height: 65px;
  }
}
@media (max-width: 991px) {
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp a,
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp p {
    font-size: 18px;
    line-height: 25px;
  }
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp a img,
  nav img {
    width: 30px;
  }
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp h4 {
    font-size: 20px;
    line-height: 30px;
  }
  .Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO a {
    font-size: 15px;
    line-height: 20px;
  }
  .Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz h1 {
    font-size: 35px;
    line-height: 50px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
    right: 95px;
  }
  .Backstagelandingpage_navheaderBackstage__9p2NY .Backstagelandingpage_MainHeadingHead__Mpbn\\+ {
    font-size: 43px;
    line-height: 50px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuLi__SEL2V {
    width: 44%;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuSubLi__\\+JeiS {
    width: 35%;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuLi__SEL2V a {
    font-size: 24px;
    line-height: 34px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T img {
    width: 36px;
    margin-bottom: 10px !important;
  }
}
@media (max-width: 767px) {
  .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE .Backstagelandingpage_BackStageMaharajaRight__R6vnE,
  .Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z,
  .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_Row__gfnt4,
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerImgSec__mdNDf,
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_LatestNewsSection__CrsGU .Backstagelandingpage_TeamInnerTextSec__Ytbxp a,
  .Backstagelandingpage_WrapperOurTeam__JW5qZ h4,
  .Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreRight__kG1P5 p {
    text-align: center;
  }
  .Backstagelandingpage_WTGBSectionLeft__CbXmj .Backstagelandingpage_ImageBottomInfoSpan__qxCA0 {
    display: block;
  }
  .Backstagelandingpage_SeeMoreBtn__E6xir button {
    font-size: 26px;
    line-height: 36px;
  }
  .Backstagelandingpage_SeeMoreBtn__E6xir {
    bottom: 52px;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 h4 {
    border-image-width: 0 0 6px 0;
    font-size: 20px;
    line-height: 28px;
    padding-bottom: 0;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_Row__gfnt4 {
    margin-right: 0;
    margin-left: 0;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerImgSec__mdNDf,
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerTextSec__Ytbxp {
    margin: 0;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerTextSec__Ytbxp .Backstagelandingpage_ReadMoreCmn__tCmlt span {
    margin-right: 4px;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerTextSec__Ytbxp .Backstagelandingpage_ReadMoreCmn__tCmlt img {
    width: auto;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WrapperWhatWeDoTop__wuaMW {
    background-size: 100% 100%;
    padding: 45px 0 30px;
  }
  .Backstagelandingpage_TeamDarkBCGroung__xTYxT,
  .Backstagelandingpage_WhoWeAreSection__sBp4Q {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4:nth-child(odd) {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4.Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    padding: 100px 0;
  }
  .Backstagelandingpage_FooterBackstage__HSsC1 {
    margin-top: -65px;
  }
  .Backstagelandingpage_FooterBackstage__HSsC1 .Backstagelandingpage_footerMid__LJX7J {
    padding-left: 25px;
  }
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_OurTeamHederTop__JoHdl {
    padding: 40px 15px;
    width: 100%;
    margin: auto;
  }
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    padding: 50px 0 100px;
  }
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSection__sBp4Q {
    padding: 75px 0;
  }
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_bottomNewWhoWeare__Fykbk {
    padding: 0 0 20px;
  }
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input::placeholder,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy select::placeholder,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy textarea::placeholder {
    font-size: 20px;
    line-height: 32px;
  }
  .Backstagelandingpage_FooterBackstage__HSsC1 .Backstagelandingpage_copyrightTextNew__weF7i {
    font-size: 8px;
    line-height: 8px;
    margin: 25px 0 10px;
  }
  .Backstagelandingpage_ReadMoreCmn__tCmlt span {
    border-image-width: 0 0 8px 0;
  }
  .Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_MobileCommonBannerNew__tr8w0,
  .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_ipsBackImg__8tOVO,
  .Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP .Backstagelandingpage_emailInput__bbAkb,
  .Backstagelandingpage_WrapperContactBackstage__V-Mv3 .Backstagelandingpage_ContactBsSection__jeSI5 form,
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_BannerCommonText__Ethep,
  .Backstagelandingpage_dropdownNewContact__-UtAb {
    width: 100%;
  }
  .Backstagelandingpage_TeamHyperLink__fZURU img,
  .Backstagelandingpage_contactSection__PnW0L .Backstagelandingpage_socialIcon__i-sVT img,
  .Backstagelandingpage_dropdownArrowImg__WwpF4 {
    width: 25px;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE,
  .Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_TPBottom__VuTE3,
  .Backstagelandingpage_dropdownNewContact__-UtAb {
    padding: 0;
  }
  .Backstagelandingpage_dropdownNewContact__-UtAb ul li {
    max-width: 100%;
  }
  .Backstagelandingpage_dropdownNewContact__-UtAb ul li img {
    width: 25px;
    padding-right: 5px;
  }
  .Backstagelandingpage_dropdownNewContact__-UtAb ul {
    display: block;
    width: 100%;
  }
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy input,
  .Backstagelandingpage_ContactBsSection__jeSI5 .Backstagelandingpage_ContactParaNew__mfcvy select,
  .Backstagelandingpage_WrapperContactBackstage__V-Mv3 .Backstagelandingpage_ContactBsSectionBottom__m7wzK .Backstagelandingpage_ContactParaNew__mfcvy {
    font-size: 20px;
    line-height: 36px;
  }
  .Backstagelandingpage_contactSection__PnW0L .Backstagelandingpage_socialIcon__i-sVT span {
    font-weight: 500 !important;
    font-size: 11px !important;
    line-height: 14px !important;
    color: #000 !important;
  }
  .Backstagelandingpage_contactSection__PnW0L .Backstagelandingpage_contactinfoMain__9aeNB {
    display: flex !important;
  }
  .Backstagelandingpage_BackStageContactFooter__sHJHg {
    padding: 60px 15px !important;
  }
  .Backstagelandingpage_contactSection__PnW0L .Backstagelandingpage_contactinfoMain__9aeNB .Backstagelandingpage_mainInfo__kxrrh:first-child span {
    display: inline-block !important;
  }
  .Backstagelandingpage_contactTopInfo__83I2e .Backstagelandingpage_contactinfoMain__9aeNB .Backstagelandingpage_mainInfo__kxrrh span {
    margin-top: 0 !important;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuLi__SEL2V a,
  .Backstagelandingpage_CreditSection__RQ6lu p,
  .Backstagelandingpage_ExtraParaIpinside__mBhvY p,
  .Backstagelandingpage_ReadMoreCmn__tCmlt,
  .Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z td,
  .Backstagelandingpage_contactSection__PnW0L .Backstagelandingpage_contactTopInfo__83I2e p {
    font-size: 16px;
    line-height: 21px;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l
    .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE
    .Backstagelandingpage_BackStageMaharajaLeft__EQbuW
    h3
    br,
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l
    .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE
    .Backstagelandingpage_BackStageMaharajaRight__R6vnE
    p
    br,
  .Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_BannerCommonImg__HNDYC,
  .Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz .Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO a img,
  .Backstagelandingpage_CreditSection__RQ6lu p br,
  .Backstagelandingpage_ExtraParaIpinside__mBhvY p br,
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p h3 br,
  .Backstagelandingpage_ImageBottomInfoSpan__qxCA0 br,
  .Backstagelandingpage_MaharajaBannerImg__6LkA-,
  .Backstagelandingpage_WhoWeAreSectionNewBottomCutImg__aIRJd,
  .Backstagelandingpage_WrapperContactBackstage__V-Mv3 .Backstagelandingpage_ContactBsSectionTop__hqInV p br,
  .Backstagelandingpage_WrapperGuppyIntro__Njw19 p br,
  .Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WTGBSectionRight__Gg6VG img,
  .Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreRight__kG1P5 p br,
  .Backstagelandingpage_WrapperWhatWeSell__w4S7y .Backstagelandingpage_WhoWeAreRight__kG1P5 p br,
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSectionRight__Gg6VG,
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF
    .Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX
    .Backstagelandingpage_WTGBSectionLeft__CbXmj
    .Backstagelandingpage_WrapperWhoWeAre__7UPpF
    .Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX
    .Backstagelandingpage_WTGBSectionRight__Gg6VG {
    display: none;
  }
  .Backstagelandingpage_ContactTop__-w1Bj::before,
  .Backstagelandingpage_bannerSlider__us3k0 .Backstagelandingpage_SliderImg__TPJC9,
  .Backstagelandingpage_bannerSlider__us3k0 .Backstagelandingpage_bannerSliderBtn__2KGef {
    display: none !important;
  }
  .Backstagelandingpage_contactSection__PnW0L .Backstagelandingpage_contactinfoMain__9aeNB .Backstagelandingpage_mainInfo__kxrrh .Backstagelandingpage_socialIcon__i-sVT {
    text-align: left !important;
  }
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    padding: 30px 15px;
    margin-top: 0;
  }
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_BannerCommon__QhnJj {
    margin-top: 0;
  }
  .Backstagelandingpage_WrapperNews__O2k-J .Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_BackBtnBSCommonNew__B5Ati {
    top: 20px;
    left: 30px;
  }
  .Backstagelandingpage_WrapperWhatWeSell__w4S7y .Backstagelandingpage_TeamLightBCGroung__JogsD {
    padding: 50px 15px 0;
    background-size: 100% 100%;
  }
  .Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe p {
    justify-content: left;
    text-align: left;
    font-size: 20px;
    line-height: 23px;
    height: auto;
  }
  .Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_SellProductPara__\\+ONaV {
    padding: 15px 5px;
  }
  .Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_StoryInformationBackstageRight__M101Z h4 {
    font-size: 24px;
    line-height: 31px;
    margin: 0 auto 30px;
  }
  .Backstagelandingpage_CreditSection__RQ6lu {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .Backstagelandingpage_BannerCommon__QhnJj,
  .Backstagelandingpage_ExtraParaIpinside__mBhvY {
    margin-top: -50px;
  }
  .Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz {
    padding: 50px 0;
  }
  .Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO a,
  .Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz a {
    font-size: 10px;
    line-height: 13px;
  }
  .Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz h1 {
    font-size: 32px;
    line-height: 37px;
    margin-bottom: 0;
  }
  .Backstagelandingpage_ImageBottomInfoSpan__qxCA0 {
    font-size: 12px;
    line-height: 15px;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 {
    padding: 60px 15px;
    text-align: center;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_ExtraParaIpinside__mBhvY {
    padding: 50px 0 20px;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 p {
    text-align: left;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 a {
    display: block;
    margin-bottom: 40px;
  }
  .Backstagelandingpage_GIMain__ZvQZM h1,
  .Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WhoWeAreSection__sBp4Q h1,
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_BsH1__T6mc9 {
    margin-bottom: 0;
  }
  .Backstagelandingpage_MobileIntroducingImgNew__-zkqx {
    display: block;
    width: 100%;
    margin-top: -50px;
  }
  .Backstagelandingpage_MobileMaharajaImageNew__PDwYm {
    display: block;
    width: 100%;
    margin-top: -44px;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_MaharajaBannerImg__6LkA- {
    margin-top: -30px;
  }
  .Backstagelandingpage_WrapperGuppyIntro__Njw19,
  .Backstagelandingpage_WrapperTemplatePage__p9CWA {
    background: #e4f2ff;
  }
  .Backstagelandingpage_WrapperTemplatePage__p9CWA .Backstagelandingpage_WhoWeAreSection__sBp4Q {
    padding: 50px 0 0;
  }
  .Backstagelandingpage_GIMain__ZvQZM p.Backstagelandingpage_paraTop__hu9EY {
    margin: 30px 0;
  }
  .Backstagelandingpage_GIMain__ZvQZM p.Backstagelandingpage_paraBottom__FUOMo {
    margin: 36px 0 40px;
  }
  .Backstagelandingpage_WhoWeAreRightNew__NN1nW,
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_Row__gfnt4 {
    margin-bottom: 40px;
  }
  .Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX {
    padding: 0 0 60px;
  }
  .Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX h2 {
    margin: 20px 0;
  }
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSection__kTe6v {
    padding: 30px 0;
  }
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSection__sBp4Q {
    margin-top: -40px;
  }
  .Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_BackBtnBSCommonNew__B5Ati {
    width: 36px;
    top: 90px;
    left: 20px;
  }
  .Backstagelandingpage_ReadMoreCmn__tCmlt img {
    width: 28px;
  }
  .Backstagelandingpage_BsComBtn__IHULv {
    padding: 5px 20px;
  }
  .Backstagelandingpage_BsH1__T6mc9,
  .Backstagelandingpage_BsH2__pgYpZ,
  .Backstagelandingpage_BsH3__KKWUT {
    font-size: 32px;
    line-height: 37px;
    margin-bottom: 20px;
  }
  .Backstagelandingpage_BsCommaonP__GE0Hn {
    font-size: 16px;
    line-height: 22px;
  }
  .Backstagelandingpage_NewsSection__ntpF-,
  .Backstagelandingpage_WTGBSection__kTe6v {
    padding: 20px 0;
  }
  .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_Row__gfnt4 {
    flex-direction: column-reverse;
  }
  .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_WTGBSectionLeft__CbXmj p,
  .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreRight__kG1P5 p {
    margin: 16px 0 25px;
    text-align: left;
  }
  .Backstagelandingpage_WhoWeAreSection__sBp4Q {
    padding: 50px 0;
    text-align: center;
  }
  .Backstagelandingpage_WTGBSection__kTe6v h2 span {
    font-size: 24px;
    line-height: 28px;
    display: block;
    color: #000;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    width: 11px;
    height: 25px;
    left: -22px;
    top: 11px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    width: 13px;
    height: 25px;
    right: 190px;
    top: 11px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuLi__SEL2V {
    width: 60%;
    padding: 7px 30px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuSubLi__\\+JeiS {
    width: 50%;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
    position: initial;
    margin-left: 30px;
  }
  .Backstagelandingpage_navheaderBackstage__9p2NY .Backstagelandingpage_navheaderBgImg__JIePU {
    height: 72px;
  }
  .Backstagelandingpage_navbarInnerInfo__NPMxs {
    flex-direction: row-reverse;
  }
  .Backstagelandingpage_SocialIconMenu__8JHy8 {
    margin-top: 50px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB li a {
    font-size: 16px;
    line-height: 20px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T img {
    width: 24px;
    margin-bottom: 5px !important;
    transition: 1s ease-in-out;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover img.Backstagelandingpage_BackstageMenuMainNavHover__Ajz1W {
    transform: rotate(90deg);
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuBottom__woCpn p {
    font-size: 14px;
    line-height: 18px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BackstageMenuBottom__woCpn .Backstagelandingpage_SocialIconMenu__8JHy8 img {
    width: 34px;
    height: 34px;
  }
  .Backstagelandingpage_BsComBtn__IHULv {
    font-size: 16px;
    line-height: 21px;
    border-image-outset: 6px;
  }
  .Backstagelandingpage_BsComBtn__IHULv img {
    width: 22px;
  }
  .Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP h3,
  .Backstagelandingpage_navheaderBackstage__9p2NY .Backstagelandingpage_MainHeadingHead__Mpbn\\+ {
    font-size: 32px;
    line-height: 37px;
  }
  .Backstagelandingpage_bannerSlider__us3k0 {
    margin-top: -25px;
  }
  .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_currentIpsLogo__ofB2v {
    width: 40%;
  }
  .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe .Backstagelandingpage_currentIpsNew__lHWGU {
    width: 60px;
  }
  .Backstagelandingpage_CurrentIpsSection__6Mqki {
    margin-top: -20px;
    background-size: contain;
    padding: 20px 0 0;
  }
  .Backstagelandingpage_NewsletterSection__QI\\+5\\+ {
    padding: 25px 0;
  }
  .Backstagelandingpage_NewsletterInner__n7WiP {
    width: 100%;
    padding: 32px 20px;
  }
  .Backstagelandingpage_NewsletterSection__QI\\+5\\+ .Backstagelandingpage_NewsletterInner__n7WiP p {
    font-size: 14px;
    line-height: 20px;
  }
  .Backstagelandingpage_NewsSection__ntpF- h2,
  .Backstagelandingpage_NewsSection__ntpF- p.Backstagelandingpage_BsCommaonP__GE0Hn,
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamInnerTextSec__Ytbxp p.Backstagelandingpage_BsCommaonP__GE0Hn {
    margin-bottom: 20px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 {
    padding: 50px 0 60px;
    text-align: center;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageRight__Jc6tG p {
    margin: 16px 0 24px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageSectionBottom__jnGjp {
    margin-top: 24px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4 .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p h3 {
    margin-bottom: 24px;
    margin-top: 24px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
    .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p
    .Backstagelandingpage_GuppyStoriesBackstageSoicalMain__SHP\\+j
    span {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
    .Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p
    .Backstagelandingpage_GuppyStoriesBackstageSoicalMain__SHP\\+j
    a
    img {
    width: 150px;
  }
  .Backstagelandingpage_FooterBackstage__HSsC1 {
    padding-top: 30px;
  }
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSection__sBp4Q p {
    text-align: center;
    margin: 16px 0 25px;
  }
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX .Backstagelandingpage_WhoWeAreSectionNewBottomCutImg__aIRJd {
    margin-top: -45px;
  }
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX {
    padding-bottom: 90px;
  }
  .Backstagelandingpage_BsH4__5Dg3m {
    font-size: 24px;
    line-height: 31px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .Backstagelandingpage_TeamHyperLink__fZURU {
    font-size: 16px;
    line-height: 21px;
    margin-top: 20px;
    margin-bottom: 40px;
    text-align: center;
  }
  .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    padding: 50px 0 60px;
    margin-top: -90px;
  }
  .Backstagelandingpage_TeamLightBCGroung__JogsD {
    padding: 20px 0 60px;
    margin-top: -55px;
    background-size: contain;
  }
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_BannerCommon__QhnJj {
    padding: 0 30px;
    height: 315px;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l
    .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE
    .Backstagelandingpage_BackStageMaharajaRightRow__\\+91EL,
  .Backstagelandingpage_TeamLightBCGroung__JogsD .Backstagelandingpage_Row__gfnt4 {
    flex-direction: column-reverse;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainTop__s99xL p {
    font-size: 11px;
    line-height: 22px;
    margin-top: 0;
    padding: 0 15px;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE p {
    font-size: 16px;
    line-height: 22px;
    margin: 20px 0;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l
    .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE
    .Backstagelandingpage_BackStageMaharajaLeft__EQbuW
    h3 {
    font-size: 19px;
    line-height: 27px;
    margin-bottom: 20px;
  }
  .Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO a img {
    width: 20px;
  }
  .Backstagelandingpage_BackStageMaharajaMain__P5U2l
    .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE
    .Backstagelandingpage_BackStageMaharajaRight__R6vnE
    p {
    font-size: 11px;
    line-height: 18px;
  }
}
@media (max-width: 575px) {
  .Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz {
    padding: 5px 0 20px;
  }
  nav img {
    width: 25px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 {
    padding-top: 40px;
  }
  .Backstagelandingpage_navheaderBackstage__9p2NY .Backstagelandingpage_MainHeadingHead__Mpbn\\+ {
    font-size: 32px;
    line-height: 37px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover:before {
    left: -13px;
    top: 7px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:hover:after {
    right: 113px;
    top: 7px;
  }
}
@media (max-width: 400px) {
  .Backstagelandingpage_FooterBackstage__HSsC1 .Backstagelandingpage_footerMid__LJX7J {
    padding-left: 20px;
  }
}
.Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE .Backstagelandingpage_BackStageMaharajaRight__R6vnE img,
.Backstagelandingpage_TeamInnerImgSec__mdNDf .Backstagelandingpage_TeamInnercommonImg__1gnOS,
.Backstagelandingpage_WTGBSectionRight__Gg6VG img,
.Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerImgSec__mdNDf img,
.Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreleft__tSORb img {
  width: 100%;
  height: 500px;
  border: 7px solid #0d5268;
  border-radius: 6px;
  object-fit: cover;
}
.Backstagelandingpage_GuppyStoriesBackstageLeft__0ydND img {
  width: 100%;
  height: 500px;
  border-radius: 6px;
  object-fit: contain;
}
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerImgSec__mdNDf img {
  object-fit: fill;
}
.Backstagelandingpage_WrapperWhoWeAre__7UPpF .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_WTGBSectionRight__Gg6VG img {
  height: auto;
  object-fit: unset;
}
.Backstagelandingpage_WrapperGuppyIntro__Njw19 .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
  padding: 120px 0;
}
.Backstagelandingpage_WrapperMain__oLyIf .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreRight__kG1P5 .Backstagelandingpage_ReadMoreCmn__tCmlt span {
  text-align: center;
  display: inline-block;
  margin-right: 20px;
  padding: 0;
}
.Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
  .Backstagelandingpage_GuppyStoriesBackstageSectionTop__wmes2
  .Backstagelandingpage_GuppyStoriesBackstageRight__Jc6tG,
.Backstagelandingpage_TeamInnerTextSec__Ytbxp,
.Backstagelandingpage_WTGBSectionLeft__CbXmj,
.Backstagelandingpage_WrapperMain__oLyIf .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreRight__kG1P5 {
  padding-left: 40px;
}
.Backstagelandingpage_WhoWeAreRightNew__NN1nW .Backstagelandingpage_IntoductionParanew__FAIdO {
  width: 70%;
  margin: 0 auto 50px;
}
.Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_IntoductionParanew__FAIdO {
  width: 72%;
  margin: 0 auto 50px;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_CreditSection__RQ6lu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 80px 60px;
  position: relative;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_CreditSection__RQ6lu p,
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_ExtraParaIpinside__mBhvY p {
  width: 75%;
  margin: auto;
  font-weight: 400;
  font-size: 21px;
  line-height: 30px;
  text-align: center;
  color: #000;
}
.Backstagelandingpage_StoryInformationBackstageLeft__VsqSq img {
  width: 100%;
  height: 100%;
}
.Backstagelandingpage_CreditSectionTop__yqspF .Backstagelandingpage_CreditSection__RQ6lu {
  margin-top: -125px;
}
.Backstagelandingpage_IPInsideFirstMAinPara__H1494 {
  padding-top: 60px;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_StoryInformationBackstageLeft__VsqSq {
  padding-left: 0;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_ExtraParaIpinside__mBhvY {
  margin-top: -75px;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_StoryInformationBackstageLeft__VsqSq img {
  height: 860px;
  object-fit: cover;
}
.Backstagelandingpage_CopyrightTextNew__zN1j0 span {
  position: absolute;
  bottom: 15px;
  left: 15px;
  color: #fff;
  font-size: 12px;
  line-height: 15px;
  text-align: left;
}
@media (min-width: 768px) and (max-width: 1199px) {
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_liMainBs__s7L8T:first-child .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
    right: 20px;
  }
  .Backstagelandingpage_BackstageMenuMain__Fhsr6 .Backstagelandingpage_BAckstageSubmenu__MQ\\+VB {
    right: 56px;
  }
}
.Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WTGBSection__kTe6v {
  background-size: 100% 100%;
  margin-top: -95px;
  position: relative;
  padding: 80px 60px;
}
.Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WhoWeAreSection__sBp4Q {
  padding: 90px 60px 160px;
  background: #b3e8ec;
}
.Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_OurStoryExtraParaNew__qxch2 {
  margin: 80px 0 100px;
  text-align: center;
}
.Backstagelandingpage_MainWWANewExtraImg__ygQ07 {
  border: 7px solid #0d5268;
  border-radius: 6px;
}
@media (min-width: 768px) {
  .Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe p {
    padding: 5px 35px;
  }
  .Backstagelandingpage_BannerCommon__QhnJj .Backstagelandingpage_MobileCommonBannerNew__tr8w0,
  .Backstagelandingpage_MainWWANewExtraImg__ygQ07,
  .Backstagelandingpage_SellProductMain__kXQS6 .Backstagelandingpage_SharePlusSign__YpVT0,
  .Backstagelandingpage_StoryInformationMobileBottom__qIpKa,
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_TeamInnerTextSec__Ytbxp .Backstagelandingpage_mobileteamtitle__EjNcV,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_NewGuppyIPStoryPAra__yHRIy .Backstagelandingpage_MobileBreakerImg__-L7Hh,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_TopSectionbreaker1BN__8nGyk .Backstagelandingpage_MobileBreakerImg__-L7Hh,
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamInnerMobileSectionImg__OTLsc {
    display: none;
  }
  .Backstagelandingpage_bannerSlider__us3k0 .Backstagelandingpage_MobileBannerBackstageImg__HT2SP {
    display: none !important;
  }
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_TeamInnerImgSec__mdNDf p {
    font-size: 35px;
    line-height: 40px;
    font-weight: 700;
    padding: 25px 0 0;
  }
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_Row__gfnt4,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_WTGBSection__kTe6v .Backstagelandingpage_Row__gfnt4 {
    align-items: flex-start;
  }
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_TeamInnerImgSec__mdNDf:nth-child(2n) a,
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_TeamInnerImgSec__mdNDf:nth-child(2n) p {
    text-align: right;
  }
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_TeamInnerImgSec__mdNDf:nth-child(odd) a,
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_TeamInnerImgSec__mdNDf:nth-child(odd) p {
    text-align: left;
  }
}
@media (max-width: 767px) {
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_ExtraParaIpinside__mBhvY,
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_mainRel__9Egqz .Backstagelandingpage_TeamLightBCGroung__JogsD {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  }
  .Backstagelandingpage_StoryInformationDesktopBottom__A7ixd,
  .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_TeamInnerTextSec__Ytbxp .Backstagelandingpage_desktopteamtitle__DV1kL,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_NewGuppyIPStoryPAra__yHRIy .Backstagelandingpage_desktopBreakerImg__PVpny,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_TopSectionbreaker1BN__8nGyk .Backstagelandingpage_desktopBreakerImg__PVpny,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_WTGBSectionRight__Gg6VG img,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_WTGBSectionRight__Gg6VG span,
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WTGBSectionRight__Gg6VG,
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamInnerImgSec__mdNDf {
    display: none;
  }
  .Backstagelandingpage_CopyrightTextNewMobile__Ib3yh {
    display: block;
  }
  .Backstagelandingpage_TopSectionbreaker1BN__8nGyk p {
    padding: 30px !important;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_StoryInformationBackstageLeft__VsqSq img {
    height: 100% !important;
  }
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_mainRel__9Egqz .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    margin-top: -40px;
  }
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_globalCreaterNew__F3wLH .Backstagelandingpage_TeamInnerTextSec__Ytbxp p {
    text-align: center;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamInnerMobileSectionImg__OTLsc img {
    border: 7px solid #0d5268;
    border-radius: 6px;
  }
  .Backstagelandingpage_WrapperOurTeam__JW5qZ .Backstagelandingpage_TeamInner__E\\+B0e .Backstagelandingpage_Row__gfnt4 {
    margin-bottom: 10px;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_CreditSection__RQ6lu p,
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_ExtraParaIpinside__mBhvY p {
    font-size: 16px;
    line-height: 20px !important;
    width: 100%;
    margin: 10px auto !important;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_ExtraParaIpinside__mBhvY {
    margin-top: -35px;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_StoryInformationBackstageLeft__VsqSq,
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_TeamDarkBCGroung__xTYxT .Backstagelandingpage_WhatWeDoInner__pB6K4 {
    padding: 0;
  }
  .Backstagelandingpage_CreditSectionTop__yqspF .Backstagelandingpage_CreditSection__RQ6lu {
    margin-top: -25px;
  }
  .Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE .Backstagelandingpage_BackStageMaharajaRight__R6vnE img,
  .Backstagelandingpage_GuppyStoriesBackstageLeft__0ydND img,
  .Backstagelandingpage_TeamInnerImgSec__mdNDf .Backstagelandingpage_TeamInnercommonImg__1gnOS,
  .Backstagelandingpage_WTGBSectionRight__Gg6VG img,
  .Backstagelandingpage_WhatWeDoInner__pB6K4 .Backstagelandingpage_TeamInnerImgSec__mdNDf img,
  .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreleft__tSORb img {
    height: auto;
  }
  .Backstagelandingpage_WrapperGuppyIntro__Njw19 .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    padding: 60px 0 80px;
  }
  .Backstagelandingpage_WhoWeAreRightNew__NN1nW .Backstagelandingpage_IntoductionParanew__FAIdO,
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_IntoductionParanew__FAIdO {
    width: 100%;
  }
  .Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4
    .Backstagelandingpage_GuppyStoriesBackstageSectionTop__wmes2
    .Backstagelandingpage_GuppyStoriesBackstageRight__Jc6tG,
  .Backstagelandingpage_TeamInnerTextSec__Ytbxp,
  .Backstagelandingpage_WTGBSectionLeft__CbXmj,
  .Backstagelandingpage_WrapperMain__oLyIf .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_WhoWeAreRight__kG1P5 {
    padding-left: 15px;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_CreditSection__RQ6lu {
    padding: 45px 0 60px;
  }
  .Backstagelandingpage_CurrentIpsSection__6Mqki .Backstagelandingpage_CurrentIpsInner__4tGZe {
    padding: 10px 0;
  }
  .Backstagelandingpage_GuppyStoriesBackstageImgMobile__aZqK6 {
    margin-top: 35px;
  }
  .Backstagelandingpage_GuppyStoriesBackstageImgMobile__aZqK6 img {
    margin-bottom: -35px;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_IntoductionParanew__FAIdO {
    text-align: center;
  }
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l .Backstagelandingpage_TeamDarkBCGroung__xTYxT {
    margin-top: -63px;
  }
  .Backstagelandingpage_NewGuppyIPStoryPAra__yHRIy p {
    line-height: 30px !important;
    margin: 30px 0 0 !important;
  }
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WTGBSection__kTe6v {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    padding: 80px 0;
    margin-top: -90px;
  }
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WhoWeAreSection__sBp4Q {
    padding: 40px 0 80px;
  }
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_OurStoryExtraParaNew__qxch2 {
    margin: 40px 0 0;
    text-align: center;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_storeIconRight__bAHYB img,
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WhoWeAreSection__sBp4Q .Backstagelandingpage_storeIconRight__bAHYB img {
    width: 142px;
  }
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_parabottomtranmedia__nUJl8 img {
    width: 150px;
    margin: 15px auto;
  }
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_paraMidiletranmedia__NHGWz {
    margin: 20px 0 !important;
  }
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WTGBSectionLeft__CbXmj img,
  .Backstagelandingpage_WrapperOurStory__fDGAl .Backstagelandingpage_WTGBSectionLeft__CbXmj p {
    margin-bottom: 20px;
  }
}

.Backstagelandingpage_bannerSlider__us3k0 {
  padding-top: 110px;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0,
.Backstagelandingpage_WrapperOurTeam__JW5qZ,
.Backstagelandingpage_WrapperOurStory__fDGAl,
.Backstagelandingpage_WrapperContactBackstage__V-Mv3,
.Backstagelandingpage_WrapperWhoWeAre__7UPpF,
.Backstagelandingpage_WrapperWhatWeDo__ATB7l {
  padding-top: 105px;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_StoryInformationBackstageSection__2pK2q .Backstagelandingpage_Row__gfnt4 {
  align-items: flex-start;
}
.Backstagelandingpage_WrapperIpInside__h\\+nE0 .Backstagelandingpage_StoryInformationBackstageLeft__VsqSq img {
  height: 580px;
  object-position: right;
}
@media (max-width: 767px) {
  .Backstagelandingpage_bannerSlider__us3k0 {
    padding-top: 80px;
  }
  .Backstagelandingpage_WrapperIpInside__h\\+nE0,
  .Backstagelandingpage_WrapperOurTeam__JW5qZ,
  .Backstagelandingpage_WrapperOurStory__fDGAl,
  .Backstagelandingpage_WrapperContactBackstage__V-Mv3,
  .Backstagelandingpage_WrapperWhoWeAre__7UPpF,
  .Backstagelandingpage_WrapperWhatWeDo__ATB7l {
    padding-top: 70px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Backstage/BackStageCss/Backstagelandingpage.module.css"],"names":[],"mappings":"AAAA;;;EAGE,+BAA+B;AACjC;AACA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,qDAAyD;EACzD,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,oCAAoC;AACtC;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,aAAa;AACf;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;;;;;;EAaE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,yDAA0D;EAC1D,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,yDAA2D;EAC3D,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,WAAW;AACb;AACA;;;;;EAKE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,qDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,SAAS;EACT,eAAe;AACjB;AACA;;EAEE,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,qDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,yDAAmE;EACnE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yDAA2D;EAC3D,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qDAA6D;EAC7D,2DAA2D;EAC3D,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,qDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yDAA6D;EAC7D,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;;EAEE,yDAA2D;EAC3D,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;AACA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yDAA6D;EAC7D,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;;EAGE,yDAA2D;EAC3D,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;;EAEE,sDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0DAA0D;EAC1D,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,0DAA2D;EAC3D,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,SAAS;AACX;AACA;;;EAGE,UAAU;EACV,SAAS;AACX;AACA;;EAEE,sDAAyD;EACzD,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,UAAU;AACZ;AAiCA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,yDAA2D;EAC3D,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yDAA0D;EAC1D,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,0DAAkD;EAClD,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,0DAAiE;EACjE,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;;;;;IAKE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;IAIE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;;IAKE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;AACA;EACE;;;;;;;IAOE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;;IAEE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;EACA;;IAEE,0DAA+D;EACjE;EACA;IACE,0DAAgE;EAClE;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;EACA;;;;;;IAME,WAAW;EACb;EACA;;;IAGE,WAAW;EACb;EACA;;;IAGE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,wBAAwB;EAC1B;EACA;;;;;;IAME,eAAe;IACf,iBAAiB;EACnB;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA8BE,aAAa;EACf;EACA;;;IAGE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,0DAA0D;IAC1D,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,SAAS;IACT,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;;;IAGE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;;IAEE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,WAAW;EACb;EACA;IACE,0DAA8D;IAC9D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;EACX;EACA;IACE,0DAA+D;IAC/D,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,SAAS;EACX;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,6BAA6B;IAC7B,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;IAGE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;;;;IAIE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;;;;;IAKE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;;;;IAIE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;;;;IAIE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;;;;IAIE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,QAAQ;EACV;EACA;IACE,YAAY;IACZ,QAAQ;EACV;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;;;;EAKE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,yDAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;;;;;;;;IAQE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;;IAEE,uBAAuB;EACzB;EACA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,0DAAgE;EAClE;EACA;;;;;;;;IAQE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0DAAgE;IAChE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;;;;;;IAME,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,WAAW;EACb;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,0DAAgE;IAChE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;;IAEE,YAAY;EACd;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;;;;;;IAME,iBAAiB;EACnB;AACF","sourcesContent":[".BSHyperLinkPriviousNextMain a span,\n.BackstageMenuMain .BackstageMenuSubLi a,\n.TeamHyperLink {\n  text-decoration-line: underline;\n}\n.BsComBtn,\n.BsComYellowBtn {\n  border-style: solid;\n  cursor: pointer;\n}\n.BsComBtn {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  font-family: Kodchasan, sans-serif;\n  color: #fff;\n  background: #0d5268;\n  border-image: url(../../assets/images/BsComBtnBorder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 8px;\n  border-image-outset: 8px;\n  padding: 5px 20px;\n}\n.BsH1,\n.BsH2 {\n  font-weight: 700;\n  color: #000;\n  text-align: center;\n  font-family: \"Cabin Sketch\", cursive;\n}\n.BackstageMenuMain,\n.WrapperIpInside,\n.WrapperIpInside .WTGBSection,\n.WrapperMain,\n.WrapperOurTeam {\n  background: #e4f2ff;\n}\n.Row {\n  align-items: center;\n}\n.BsH1 {\n  font-size: 96px;\n  line-height: 112px;\n}\n.BsH2 {\n  font-size: 72px;\n  line-height: 84px;\n  margin-bottom: 40px;\n}\n.BsH3,\n.BsH4 {\n  margin-bottom: 30px;\n  color: #000;\n  font-weight: 700;\n}\n.BsH3 {\n  font-size: 56px;\n  line-height: 66px;\n  font-family: \"Cabin Sketch\", cursive;\n}\n.BsH4,\n.DropDownButtonChild {\n  font-family: Kodchasan, sans-serif;\n}\n.BsH4 {\n  font-size: 48px;\n  line-height: 62px;\n  text-align: left;\n}\n.BsCommaonP {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.02em;\n  color: #000;\n}\n.BsCommaonPS {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.02em;\n  font-weight: bold;\n  color: #000;\n}\n.BsCommaonPM {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 30px;\n  letter-spacing: 0.02em;\n  font-weight: bold;\n  color: #000;\n}\n.TeamHyperLink {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  margin-top: 40px;\n  display: block;\n  margin-left: 5px;\n}\n.navheaderBackstage {\n  padding-top: 20px;\n}\n.navheaderBackstage .navheaderBgImg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n}\n.navheaderBackstage .MainHeadingHead {\n  font-weight: 700;\n  font-size: 68px;\n  line-height: 80px;\n  color: #e4f2ff;\n}\n.WrapperContactBackstage,\n.WrapperTemplatePage,\n.WrapperWhatWeSell,\n.WrapperWhoWeAre {\n  background-color: #e4f2ff;\n}\n.BackstageMenuMain {\n  padding-top: 100px;\n  min-height: 100vh;\n}\n.BackstageMenuMain .BackstageMenuLi {\n  background: #56cdd5;\n  border-radius: 14px;\n  text-align: left;\n  padding: 10px 30px;\n  margin-bottom: 24px;\n  width: 43%;\n}\n.BackstageMenuMain .BackstageMenuLi a {\n  color: #000;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n}\n.BackstageMenuMain .BackstageMenuSubLi {\n  width: 35%;\n  display: inline-block;\n}\n.BackstageMenuMain .BackstageMenuBottom p {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #0d5268;\n  margin-bottom: 15px;\n}\n.BackstageMenuMain .BackstageMenuBottom .SocialIconMenu img {\n  width: 47px;\n  height: 45px;\n  margin-right: 18px;\n}\n.BackstageMenuMain .BackstageMenuBottom {\n  margin-top: 50px;\n}\n.BackstageMenuMain .BAckstageSubmenu li {\n  list-style-type: disc;\n  margin-bottom: 20px;\n}\n.BackstageMenuMain .BAckstageSubmenu li a {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n}\n.BackstageMenuMain .BAckstageSubmenu li:hover a {\n  color: #0d5268;\n  text-decoration: underline;\n}\n.BackstageMenuMain .BAckstageSubmenu {\n  position: absolute;\n  right: 300px;\n  top: 0;\n  display: none;\n}\n.BackstageMenuMain .liMainBs:hover .BAckstageSubmenu {\n  display: block;\n  z-index: 1;\n}\n.BackstageMenuMain .liMainBs {\n  position: relative;\n  cursor: pointer;\n}\n.BackstageMenuMain .liMainBs:nth-child(2) .BAckstageSubmenu {\n  top: -85px;\n}\n.BackstageMenuMain .liMainBs:first-child .BAckstageSubmenu {\n  right: 220px;\n}\n.BackstageMenuMain .liMainBs:hover .BackstageMenuSubLi {\n  background-color: #0d5268;\n}\n.BackstageMenuMain .liMainBs:hover .BackstageMenuSubLi a {\n  color: #d9eb41;\n}\n.BackstageMenuMain .liMainBs:hover .BackstageMenuMainNavimg,\n.BackstageMenuMainNavHover,\n.CopyrightTextNewMobile,\n.CurrentIpsSection .CurrentIpsInner:hover .currentIpsLogo,\n.CurrentIpsSection .CurrentIpsInner:hover .currentIpsNew,\n.DropDownButtonNew button:hover::before,\n.MobileIntroducingImgNew,\n.MobileMaharajaImageNew,\n.WTGBSectionLeft .ImageBottomInfoSpan,\n.WrapperWhatWeSell\n  .GuppyStoriesBackstageSection\n  .GuppyStoriesBackstageSectionTop,\n.WrapperWhatWeSell .GuppyStoriesBackstageSection h2 {\n  display: none;\n}\n.BackstageMenuMain .liMainBs:hover:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -40px;\n  background-image: url(../../assets/images/BsHoverLeft.png);\n  background-repeat: no-repeat;\n  width: 28px;\n  height: 65px;\n}\n.BackstageMenuMain .liMainBs:hover:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  background-image: url(../../assets/images/BsHoverRight.png);\n  background-repeat: no-repeat;\n  width: 36px;\n  height: 69px;\n}\n.BackstageMenuMain .liMainBs:hover .BackstageMenuMainNavHover {\n  display: inline-block;\n}\n.navbarInnerInfo {\n  z-index: 2;\n}\n.navheaderBackstageNew {\n  position: sticky;\n  z-index: 2;\n  top: 0;\n}\n.navheaderBackstageNew .navheaderMainInner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding-top: 25px;\n  width: 100%;\n}\n.StoryInformationBackstageSection .StoryInformationBackstageRight table,\n.WhoWeAreSectionNewBottomCutImg,\n.WrapperGuppyIntro .TeamDarkBCGroung img,\n.WrapperTemplatePage .WhoWeAreSectionNewBottomCutImg,\n.navheaderBackstageNew .navheaderBgImg {\n  width: 100%;\n}\n.BsComYellowBtn {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  border-image: url(../../assets/images/yellow-border-img.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 8px;\n  border-image-outset: 8px;\n  padding: 5px 20px;\n  background: #d9eb41;\n}\n.bannerSlider .bannerSliderBtn {\n  position: absolute;\n  bottom: 95px;\n  left: 0;\n  right: 0;\n  margin: auto;\n  text-align: center;\n  display: inline-block;\n  width: max-content;\n}\n.WTGBSection {\n  padding: 60px;\n}\n.ReadMoreCmn {\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 36px;\n  text-align: center;\n  color: #0d5268;\n  cursor: pointer;\n  border: 0;\n  background: 0 0;\n}\n.CurrentIpsSection,\n.WhoWeAreSection {\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  position: relative;\n}\n.ReadMoreCmn img {\n  width: 52px;\n}\n.ReadMoreCmn span {\n  border-image: url(../../assets/images/ReadmoreBorderBottom.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 0 0 12px 0;\n  border-image-outset: 0 0 8px 0;\n  border-style: solid;\n  display: inline-block;\n  margin-right: 15px;\n}\n.WhoWeAreSection {\n  background-image: url(../../assets/images/WhoWEAreNewBGDarkNew.png);\n  padding: 120px 60px;\n  margin-top: -75px;\n}\n.WrapperMain .WhoWeAreSection {\n  margin-top: -10px;\n}\n.WhoWeAreSection p,\n.WrapperWhoWeAre .WTGBSectionLeft p {\n  margin-bottom: 45px;\n}\n.CurrentIpsSection {\n  background-image: url(../../assets/images/NewBGLightBS.png);\n  padding: 60px 0 0;\n  margin-top: -55px;\n}\n.CurrentIpsSection .CurrentIpsInner {\n  position: relative;\n  padding: 10px;\n  cursor: pointer;\n}\n.CurrentIpsSection .CurrentIpsInner .ipsBackImg {\n  filter: blur(10px);\n  -webkit-filter: blur(10px);\n  width: 100%;\n}\n.CurrentIpsSection .CurrentIpsInner:hover .ipsBackImg {\n  filter: blur(0px);\n  -webkit-filter: blur(0px);\n  width: 100%;\n}\n.CurrentIpsSection .CurrentIpsInner .currentIpsLogo {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: 180px;\n}\n.CurrentIpsSection .CurrentIpsInner:nth-child(3) .currentIpsLogo {\n  width: 310px;\n}\n.CurrentIpsSection .CurrentIpsInner:hover .SeeMoreBtn {\n  visibility: visible;\n  cursor: pointer;\n}\n.CurrentIpsSection .CurrentIpsInner .currentIpsNew {\n  position: absolute;\n  top: 30px;\n  right: 45px;\n  width: 80px;\n}\n.NewsletterSection {\n  padding: 80px 0;\n  text-align: center;\n}\n.NewsletterInner {\n  border-image: url(../../assets/images/newsletterBSborder.png);\n  filter: drop-shadow(-12px -12px 24px rgba(91, 91, 91, 0.1));\n  background: #b3e8ec;\n  padding: 32px 0;\n  width: 85%;\n  margin: auto;\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 10px;\n  border-image-outset: 0 5px;\n  cursor: pointer;\n  border-style: solid;\n}\n.NewsletterSection .NewsletterInner h3 {\n  margin-bottom: 16px;\n  font-size: 48px;\n  line-height: 56px;\n}\n.NewsletterSection .NewsletterInner p {\n  margin-bottom: 36px;\n  font-size: 18px;\n  line-height: 26px;\n}\n.NewsletterSection .NewsletterInner .emailInput {\n  width: 35%;\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  border-image: url(../../assets/images/inputBorderBs.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 8px;\n  cursor: pointer;\n  border-style: solid;\n}\n.NewsletterSection .NewsletterInner .emailInput input {\n  padding: 13px 20px;\n  border: 0;\n  background-color: transparent;\n  width: 90%;\n}\n.NewsletterSection .NewsletterInner .emailInput input:focus {\n  outline: 0;\n  border: 0;\n}\n.NewsSection {\n  text-align: center;\n  padding-bottom: 60px;\n}\n.NewsSection h2,\n.WrapperOurStory .WTGBSection h1 {\n  margin-bottom: 30px;\n}\n.GuppyStoriesBackstageSection .GuppyStoriesBackstageRight p,\n.NewsSection p.BsCommaonP {\n  margin-bottom: 50px;\n}\n.GuppyStoriesBackstageSection {\n  background-image: url(../../assets/images/GuppyStoriesBG.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  padding: 120px 60px 60px;\n}\n.FooterBackstage,\n.WrapperWhoWeAre .WTGBSection {\n  background-image: url(../../assets/images/NewBGLightBS.png);\n  background-repeat: no-repeat;\n}\n.GuppyStoriesBackstageSection .GuppyStoriesBackstageSectionBottom {\n  margin-top: 72px;\n}\n.GuppyStoriesBackstageSection .GuppyStoriesBackstageSoical h3 {\n  font-weight: 700;\n  font-size: 42px;\n  line-height: 59px;\n  color: #000;\n  font-family: \"Cabin Sketch\", cursive;\n  margin-bottom: 36px;\n}\n.GuppyStoriesBackstageSection\n  .GuppyStoriesBackstageSoical\n  .GuppyStoriesBackstageSoicalMain\n  span {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 36px;\n  margin-bottom: 36px;\n  color: #000;\n  display: block;\n}\n.GuppyStoriesBackstageSection\n  .GuppyStoriesBackstageSoical\n  .GuppyStoriesBackstageSoicalMain\n  a\n  img {\n  margin-right: 25px;\n}\n.FooterBackstage {\n  background-size: 100% 100%;\n  padding-top: 80px;\n  margin-top: -125px;\n  position: relative;\n}\n.FooterBackstage .emailInputBackstage {\n  border-image: url(../../assets/images/inputBorderBs.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 8px;\n  cursor: pointer;\n  border-style: solid;\n  position: relative;\n  display: inline-block;\n}\n.FooterBackstage .emailInputBackstage input {\n  background-color: transparent;\n}\n.BannerCommon,\n.CopyrightTextNew,\n.mainRel {\n  position: relative;\n}\n.BannerCommon .BackBtnBSCommonNew {\n  position: absolute;\n  top: 75px;\n  left: 130px;\n}\n.BannerCommonImg {\n  width: 100%;\n  height: 500px;\n  object-fit: cover;\n}\n.WrapperWhoWeAre .WhoWeAreSection {\n  margin-top: -72px;\n  position: relative;\n  padding: 75px 60px;\n}\n.WrapperWhoWeAre .WhoWeAreSectionNewBottom {\n  padding: 0;\n}\n.WrapperWhoWeAre .bottomNewWhoWeare {\n  padding: 0 60px 175px;\n}\n.WrapperWhoWeAre .WTGBSection {\n  background-size: contain;\n  margin-top: -65px;\n  padding: 120px 60px;\n  position: relative;\n}\n.WrapperWhoWeAre .WTGBSection .Row {\n  margin-bottom: 80px;\n}\n.WhoWeAreSectionNewBottom {\n  padding: 0 0 120px;\n  margin-top: 0;\n}\n.WhoWeAreSectionNewBottom h2 {\n  margin: 36px 0;\n}\n.WhoWeAreRightNew,\n.WrapperOurStory .WTGBSection .WhoWeAreRight p {\n  text-align: center;\n  margin-bottom: 50px;\n}\n.TeamDarkBCGroung {\n  background-image: url(../../assets/images/GuppyStoriesBG.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  padding: 120px 60px;\n  margin-top: -90px;\n  position: relative;\n}\n.TeamLightBCGroung,\n.WrapperTemplatePage .WhoWeAreSectionNewTop,\n.WrapperWhatWeDo .WhatWeDoInner:nth-child(odd) {\n  background-image: url(../../assets/images/NewBGLightBS.png);\n  background-repeat: no-repeat;\n}\n.TeamLightBCGroung {\n  background-size: cover;\n  padding: 120px 60px;\n  margin-top: -55px;\n}\n.WrapperOurTeam .BannerCommon {\n  text-align: center;\n  background-color: #e4f2ff;\n  padding: 0 60px;\n  height: 400px;\n  display: flex;\n}\n.WrapperOurTeam .BannerCommon .BannerCommonText {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 75%;\n  margin: auto;\n}\n.TeamHyperLink img {\n  width: 50px;\n  margin-right: 15px;\n}\n.ContactBsSection .ContactBsSectionTop,\n.GIMain,\n.WrapperNews .BannerCommonText h4,\n.WrapperWhatWeSell .WhoWeAreRight p {\n  text-align: center;\n}\n.GIMain h1 {\n  margin-bottom: 36px;\n}\n.GIMain p.paraTop {\n  margin-bottom: 60px;\n}\n.GIMain p.paraBottom {\n  margin: 36px 0 70px;\n}\n.WrapperWhatWeDo .WrapperWhatWeDoTop {\n  margin-top: -68px;\n  position: relative;\n  padding: 70px 60px 100px;\n}\n.WrapperTemplatePage .WTGBSectionLeft h4,\n.WrapperWhatWeDo .WhatWeDoInner h4 {\n  border-image: url(../../assets/images/NewBorderH4Backstage.png);\n  border-image-repeat: stretch;\n  border-image-slice: 20;\n  border-image-width: 0 0 12px 0;\n  border-image-outset: 8px;\n  border-style: solid;\n  display: inline-block;\n  padding-bottom: 12px;\n}\n.BackStageMaharajaMain .BackStageMaharajaMainBottom,\n.WrapperTemplatePage .TPBottom {\n  padding: 0 60px;\n}\n.BackStageMaharajaMain .MaharajaBannerImg {\n  width: 100%;\n  margin-top: -105px;\n  position: relative;\n}\n.BackStageMaharajaMain .BackStageMaharajaMainTop p {\n  font-style: italic;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n  color: #000;\n  margin-top: 22px;\n  padding: 0 30px;\n}\n.BackStageMaharajaMain .BackStageMaharajaMainBottom p {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.02em;\n  color: #000;\n  margin: 36px 0 80px;\n}\n.BackStageMaharajaMain .BackStageMaharajaMainBottom .BackStageMaharajaLeft h3 {\n  font-style: italic;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 45px;\n  letter-spacing: 0.02em;\n  color: #000;\n}\n.BackStageMaharajaMain .BackStageMaharajaMainBottom .BackStageMaharajaRight p {\n  font-style: italic;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n  color: #000;\n}\n.BSHyperLinkPriviousNextMain {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.BSHyperLinkPriviousNextMain span {\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n.BSHyperLinkPriviousNextMain a {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  color: #000;\n  display: inline-block;\n}\n.FooterBackstage .footerMid {\n  padding-left: 85px;\n}\n.WrapperTemplatePage .WhoWeAreSectionNewTop {\n  background-size: 100% 100%;\n  padding: 60px 60px 0;\n}\n.WrapperWhatWeDo .WhatWeDoInner p {\n  margin-bottom: 20px;\n}\n.WrapperWhatWeDo .WhatWeDoInner a.ReadMoreCmn span {\n  border-image: url(../../assets/images/ReadmoreBorderBottom.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 0 0 8px 0;\n  border-image-outset: 8px;\n  border-style: solid;\n}\n.WrapperWhatWeDo .WhatWeDoInner:nth-child(odd) {\n  background-size: 100% 100%;\n  position: relative;\n}\n.BshyperLinkStoryTitleMain h1 {\n  font-size: 68px;\n  line-height: 84px;\n}\n.CreditSection h5,\n.CreditSection p,\n.ExtraParaIpinside h5,\n.ExtraParaIpinside p {\n  font-size: 21px;\n  line-height: 27px;\n  text-align: center;\n  color: #000;\n}\n.BshyperLinkStoryTitleMain {\n  background-color: #e4f2ff;\n  padding: 35px 0;\n}\n.WrapperIpInside .BackStageMaharajaMain .MaharajaBannerImg {\n  margin-top: -70px;\n}\n.StoryInformationBackstageSection,\n.WrapperNews {\n  background: #b3e8ec;\n}\n.StoryInformationBackstageSection .StoryInformationBackstageRight {\n  padding: 30px 15px;\n}\n.StoryInformationBackstageSection .StoryInformationBackstageRight h4 {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  border-image: url(../../assets/images/NewBorderH4Backstage.png);\n  border-image-repeat: stretch;\n  border-image-slice: 20;\n  border-image-width: 0 0 7px 0;\n  border-image-outset: 8px;\n  border-style: solid;\n  width: max-content;\n}\n.StoryInformationBackstageSection .StoryInformationBackstageRight td {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  margin-bottom: 16px;\n  display: inline-block;\n  width: 50%;\n}\n.StoryInformationBackstageSection\n  .StoryInformationBackstageRight\n  td:first-child {\n  font-weight: 700;\n}\n.StoryInformationBackstageSection .StoryInformationBackstageRight img {\n  display: block;\n  margin: 0 auto 30px;\n  width: auto;\n}\n.ImageBottomInfoSpan {\n  font-style: italic;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n  color: #000;\n  display: block;\n  margin-top: 15px;\n}\n.WrapperIpInside .BSHyperLinkPriviousNextWrapper {\n  background-image: url(../../assets/images/BsNewDarkBG.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  padding: 50px 0 100px;\n  position: relative;\n}\n.ExtraParaIpinside {\n  background-image: url(../../assets/images/NewLightBSBG.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  padding: 50px 0;\n  margin-top: -40px;\n  position: relative;\n}\n.ExtraParaIpinside p {\n  font-weight: 400;\n}\n.CreditSection {\n  text-align: center;\n  padding: 50px 0;\n}\n.CreditSection h5,\n.ExtraParaIpinside h5 {\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n.CreditSection p {\n  font-weight: 400;\n}\n.SellProductMain .CurrentIpsSection .CurrentIpsInner p {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 28px;\n  text-align: center;\n  color: #000;\n  font-family: \"Cabin Sketch\", cursive;\n  height: 56px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.SellProductMain .CurrentIpsSection .CurrentIpsInner .SellProductPara {\n  background: #d9eb41;\n  border: 1.5px solid #000;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 15px;\n  align-items: center;\n}\n.SellProductMain .CurrentIpsSection {\n  padding: 60px 0;\n}\n.WrapperWhatWeSell .TeamLightBCGroung {\n  position: relative;\n  padding: 50px 60px;\n}\n.SellProductMain .SharePlusSign {\n  height: 100%;\n}\n.WrapperNews .TeamDarkBCGroung {\n  background-image: none;\n  margin-top: 0;\n  padding: 60px;\n}\n.WrapperNews .LatestNewsSection .TeamInnerTextSec h4 {\n  font-size: 36px;\n  line-height: 50px;\n  margin-bottom: 15px;\n}\n.WrapperNews .LatestNewsSection {\n  margin: 0 0 100px;\n}\n.WrapperIpInside .StoryInformationBackstageRight .BsCommaonP,\n.WrapperNews .LatestNewsSection .TeamInnerTextSec p {\n  margin-bottom: 15px;\n}\n.WrapperNews .LatestNewsSection .TeamInnerTextSec a {\n  color: #000;\n  display: block;\n  text-align: left;\n}\n.WrapperNews .LatestNewsSection .TeamInnerTextSec a span {\n  border-image: url(../../assets/images/NewBorderH4Backstage.png);\n  border-image-repeat: stretch;\n  border-image-slice: 20;\n  border-image-width: 0 0 8px 0;\n  border-image-outset: 8px;\n  border-style: solid;\n}\n.WrapperContactBackstage .TeamDarkBCGroung {\n  margin-top: 0;\n  padding: 60px;\n}\n.ContactBsSection .ContactParaNew {\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 65px;\n  color: #000;\n}\n.WrapperContactBackstage .ContactBsSection form {\n  margin: 35px auto 0;\n  width: 70%;\n}\n.ContactBsSection .ContactApprovalBox span {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  text-align: center;\n  color: #000;\n}\n.ContactBsSection .ContactParaNew input,\n.ContactBsSection .ContactParaNew select {\n  margin-bottom: 25px;\n}\n.ContactBsSection .ContactParaNew input,\n.ContactBsSection .ContactParaNew select,\n.ContactBsSection .ContactParaNew textarea {\n  padding: 0 5px;\n  font-style: italic;\n  font-weight: 700;\n  font-size: 28px;\n  color: #0d5268;\n  background: 0 0;\n  border: 0;\n}\n.ContactBsSection .ContactParaNew input:focus-visible,\n.ContactBsSection .ContactParaNew select:focus-visible,\n.ContactBsSection .ContactParaNew textarea:focus-visible {\n  outline: 0;\n  border: 0;\n}\n.ContactBsSection .ContactParaNew input::placeholder,\n.ContactBsSection .ContactParaNew textarea::placeholder {\n  border-image: url(../../assets/images/NewInputBorder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 0 0 8px 0;\n  border-image-outset: 0;\n  border-style: solid;\n  padding: 0 5px;\n  font-style: italic;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 65px;\n  color: rgb(13, 82, 104, 0.5);\n  opacity: 1;\n}\n.ContactBsSection .ContactParaNew input::-webkit-input-placeholder,\n.ContactBsSection .ContactParaNew textarea::-webkit-input-placeholder {\n  border-image: url(../../assets/images/NewInputBorder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 0 0 8px 0;\n  border-image-outset: 0;\n  border-style: solid;\n  padding: 0 5px;\n  font-style: italic;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 65px;\n  color: rgb(13, 82, 104, 0.5);\n  opacity: 1;\n}\n.ContactBsSection .ContactParaNew input:-ms-input-placeholder,\n.ContactBsSection .ContactParaNew textarea:-ms-input-placeholder {\n  border-image: url(../../assets/images/NewInputBorder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 14;\n  border-image-width: 0 0 8px 0;\n  border-image-outset: 0;\n  border-style: solid;\n  padding: 0 5px;\n  font-style: italic;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 65px;\n  color: rgb(13, 82, 104, 0.5);\n  opacity: 1;\n}\n.ContactBsSection .ContactParaNew input[type=\"tel\"]::placeholder {\n  border: 0;\n}\n.ContactBsSection .ContactParaNew input.TextNameInput::placeholder {\n  width: 180px;\n}\n.ContactBsSection .ContactParaNew input.DropDown::placeholder {\n  width: 400px;\n}\n.ContactBsSection .ContactParaNew input.EmailUserInput::placeholder {\n  width: 180px;\n}\n.ContactBsSection .ContactParaNew .TextCommentInput::placeholder {\n  width: 300px;\n}\n.ContactBsSection .ContactParaNew .DropDown {\n  width: 450px;\n}\n.ContactBsSection .ContactParaNew textarea {\n  width: 100%;\n  height: auto;\n}\n.ContactBsSection {\n  padding: 60px 60px 0;\n  position: relative;\n  background-size: contain;\n  margin-top: -80px;\n}\n.DropDownButtonParent,\n.dropdownNewContact {\n  background: #0d5268;\n  border: 4px solid #000;\n  padding: 15px;\n  display: flex;\n}\n.ContactBsSection .ContactApprovalBox {\n  margin: 50px 0;\n}\n.ContactBsSection .ContactBsSectionBottom button {\n  position: relative;\n  width: 150px;\n}\n.ContactBsSection .ContactBsSectionBottom button:hover {\n  background-color: transparent;\n  color: #0d5268;\n}\n.ContactBsSection .ContactBsSectionBottom button:focus {\n  border: 0;\n  outline: 0;\n}\n.ContactBsSection .ContactBsSectionBottom button:hover::after {\n  content: \"\";\n  position: absolute;\n  top: -8px;\n  right: -55px;\n  background-image: url(../../assets/images/BsHoverRight.png);\n  background-repeat: no-repeat;\n  width: 36px;\n  height: 69px;\n}\n.ContactBsSection .ContactBsSectionBottom button:hover::before {\n  content: \"\";\n  position: absolute;\n  top: -5px;\n  left: -40px;\n  background-image: url(../../assets/images/BsHoverLeft.png);\n  background-repeat: no-repeat;\n  width: 28px;\n  height: 65px;\n}\n.dropdownArrowImg {\n  width: 40px;\n  transform: rotate(90deg);\n  cursor: pointer;\n}\n.ContactBsSection .SuccessMessage p {\n  font-weight: 600;\n  color: #159445;\n  margin: 40px 0 0;\n}\n.dropdownNewContact {\n  justify-content: space-between;\n  align-items: center;\n  width: 110%;\n}\n.dropdownNewContact ul {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.dropdownNewContact li {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 42px;\n  color: #fff;\n  margin-bottom: 15px;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n.dropdownNewContact li img {\n  padding-right: 15px;\n  cursor: pointer;\n}\n.DropDownButtonNew button {\n  width: auto !important;\n  text-align: center;\n  padding: 0 5px;\n  font-style: italic;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 65px;\n  color: #0d5268;\n  background: 0 0;\n  border: 0;\n  position: relative;\n}\n.DropDownButtonParent {\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.DropDownButtonValue,\n.SeeMoreBtn button {\n  font-weight: 700;\n  font-size: 28px;\n  border: 0;\n  text-align: center;\n}\n.DropDownButtonValue {\n  padding: 0 5px;\n  font-style: italic;\n  line-height: 65px;\n  color: #000;\n  background: 0 0;\n}\n.DropDownButtonChild:hover {\n  background-color: transparent;\n  color: #fff;\n}\n.DropDownButtonChild {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 47px;\n  color: #fff;\n  margin-bottom: 15px;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n.FooterBackstage .copyrightTextNew {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 40px;\n  text-align: center;\n  color: #000;\n  margin: 50px 0 0;\n}\n.WrapperOurTeam .TeamLightBCGroung {\n  background-size: contain;\n  position: relative;\n  margin-top: -72px;\n}\n.WrapperOurTeam .OurTeamHederTop {\n  text-align: center;\n  padding: 0 30px 80px;\n  width: 80%;\n  margin: auto;\n}\n.WrapperOurTeam .TeamInner .Row {\n  margin-bottom: 90px;\n}\n.WrapperOurTeam .TeamInnerTextSec p a {\n  color: #000;\n}\n.currentIpsNew p {\n  background-image: url(../../assets/images/new.png);\n  background-repeat: no-repeat;\n  width: 94px;\n  height: 84px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.SeeMoreBtn button {\n  line-height: 36px;\n  color: #000;\n  background-image: url(../../assets/images/SeeMoreBtnYellowBg.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  padding: 15px 18px;\n  background-color: transparent;\n  cursor: pointer;\n}\n.SeeMoreBtn {\n  text-align: center;\n  position: absolute;\n  bottom: 72px;\n  left: 0;\n  right: 0;\n  visibility: hidden;\n}\n.WrapperIpInside .FooterBackstage {\n  margin-top: -55px;\n}\n.WrapperWhatWeDo .WhatWeDoInner .TeamInnerTextSec .ReadMoreCmn img {\n  width: auto;\n}\n@media (min-width: 1200px) {\n  .BackstageMenuMain {\n    margin-top: -15px;\n  }\n}\n@media (max-width: 1199px) {\n  .ContactBsSection .ContactParaNew .DropDown,\n  .ContactBsSection .ContactParaNew .EmailUserInput,\n  .ContactBsSection .ContactParaNew .NumberInput,\n  .ContactBsSection .ContactParaNew .TextCommentInput,\n  .ContactBsSection .ContactParaNew .TextNameInput {\n    width: auto !important;\n  }\n  .ContactBsSection .ContactParaNew .DropDown {\n    width: 450px;\n  }\n  .ContactBsSection .ContactParaNew,\n  .ContactBsSection .ContactParaNew input,\n  .dropdownNewContact li {\n    font-size: 20px;\n    line-height: 30px;\n  }\n  .WrapperNews .TeamDarkBCGroung {\n    padding: 30px;\n  }\n  .BsComBtn,\n  .WrapperNews .LatestNewsSection .TeamInnerTextSec h4 {\n    font-size: 25px;\n    line-height: 35px;\n  }\n  .BshyperLinkStoryTitleMain h1 {\n    font-size: 50px;\n    line-height: 65px;\n  }\n  .BackStageMaharajaMain\n    .BackStageMaharajaMainBottom\n    .BackStageMaharajaLeft\n    h3 {\n    font-size: 25px;\n    line-height: 32px;\n  }\n  .BsH1 {\n    font-size: 58px;\n    line-height: 85px;\n  }\n  .BsH4 {\n    font-size: 40px;\n    line-height: 52px;\n  }\n  .BackstageMenuMain .BackstageMenuLi a {\n    font-size: 30px;\n    line-height: 40px;\n  }\n  .navheaderBackstage {\n    padding-top: 0;\n  }\n  .navheaderBackstage .MainHeadingHead {\n    font-size: 54px;\n    line-height: 65px;\n  }\n  .GuppyStoriesBackstageSection\n    .GuppyStoriesBackstageSoical\n    .GuppyStoriesBackstageSoicalMain\n    a\n    img {\n    margin-right: 10px;\n  }\n  .GuppyStoriesBackstageSection .GuppyStoriesBackstageSoical h3 {\n    font-size: 32px;\n    line-height: 42px;\n  }\n  .BsCommaonP {\n    font-size: 20px;\n    line-height: 28px;\n  }\n  .BsCommaonPS {\n    font-size: 16px;\n    line-height: 28px;\n  }\n  .BsCommaonPM {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .BsH2 {\n    font-size: 60px;\n    line-height: 65px;\n  }\n}\n@media (max-width: 991px) {\n  .WrapperNews .LatestNewsSection .TeamInnerTextSec a,\n  .WrapperNews .LatestNewsSection .TeamInnerTextSec p {\n    font-size: 18px;\n    line-height: 25px;\n  }\n  .WrapperNews .LatestNewsSection .TeamInnerTextSec a img,\n  nav img {\n    width: 30px;\n  }\n  .WrapperNews .LatestNewsSection .TeamInnerTextSec h4 {\n    font-size: 20px;\n    line-height: 30px;\n  }\n  .BSHyperLinkPriviousNextMain a {\n    font-size: 15px;\n    line-height: 20px;\n  }\n  .BshyperLinkStoryTitleMain h1 {\n    font-size: 35px;\n    line-height: 50px;\n  }\n  .BackstageMenuMain .BAckstageSubmenu {\n    right: 95px;\n  }\n  .navheaderBackstage .MainHeadingHead {\n    font-size: 43px;\n    line-height: 50px;\n  }\n  .BackstageMenuMain .BackstageMenuLi {\n    width: 44%;\n  }\n  .BackstageMenuMain .BackstageMenuSubLi {\n    width: 35%;\n  }\n  .BackstageMenuMain .BackstageMenuLi a {\n    font-size: 24px;\n    line-height: 34px;\n  }\n  .BackstageMenuMain .liMainBs img {\n    width: 36px;\n    margin-bottom: 10px !important;\n  }\n}\n@media (max-width: 767px) {\n  .BackStageMaharajaMainBottom .BackStageMaharajaRight,\n  .StoryInformationBackstageSection .StoryInformationBackstageRight,\n  .WTGBSection .Row,\n  .WrapperNews .LatestNewsSection .TeamInnerImgSec,\n  .WrapperNews .LatestNewsSection .TeamInnerTextSec a,\n  .WrapperOurTeam h4,\n  .WrapperTemplatePage .WhoWeAreSection .WhoWeAreRight p {\n    text-align: center;\n  }\n  .WTGBSectionLeft .ImageBottomInfoSpan {\n    display: block;\n  }\n  .SeeMoreBtn button {\n    font-size: 26px;\n    line-height: 36px;\n  }\n  .SeeMoreBtn {\n    bottom: 52px;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner h4 {\n    border-image-width: 0 0 6px 0;\n    font-size: 20px;\n    line-height: 28px;\n    padding-bottom: 0;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner .Row {\n    margin-right: 0;\n    margin-left: 0;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner .TeamInnerImgSec,\n  .WrapperWhatWeDo .WhatWeDoInner .TeamInnerTextSec {\n    margin: 0;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner .TeamInnerTextSec .ReadMoreCmn span {\n    margin-right: 4px;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner .TeamInnerTextSec .ReadMoreCmn img {\n    width: auto;\n  }\n  .WrapperWhatWeDo .WrapperWhatWeDoTop {\n    background-size: 100% 100%;\n    padding: 45px 0 30px;\n  }\n  .TeamDarkBCGroung,\n  .WhoWeAreSection {\n    background-image: url(../../assets/images/mobileTeamDarkBg.png);\n  }\n  .WrapperWhatWeDo .WhatWeDoInner:nth-child(odd) {\n    background-image: url(../../assets/images/mobileTeamLightBg.png);\n  }\n  .WrapperWhatWeDo .WhatWeDoInner.TeamDarkBCGroung {\n    padding: 100px 0;\n  }\n  .FooterBackstage {\n    margin-top: -65px;\n  }\n  .FooterBackstage .footerMid {\n    padding-left: 25px;\n  }\n  .WrapperOurTeam .OurTeamHederTop {\n    padding: 40px 15px;\n    width: 100%;\n    margin: auto;\n  }\n  .WrapperOurTeam .TeamDarkBCGroung {\n    padding: 50px 0 100px;\n  }\n  .WrapperWhoWeAre .WhoWeAreSection {\n    padding: 75px 0;\n  }\n  .WrapperWhoWeAre .bottomNewWhoWeare {\n    padding: 0 0 20px;\n  }\n  .ContactBsSection .ContactParaNew input::placeholder,\n  .ContactBsSection .ContactParaNew select::placeholder,\n  .ContactBsSection .ContactParaNew textarea::placeholder {\n    font-size: 20px;\n    line-height: 32px;\n  }\n  .FooterBackstage .copyrightTextNew {\n    font-size: 8px;\n    line-height: 8px;\n    margin: 25px 0 10px;\n  }\n  .ReadMoreCmn span {\n    border-image-width: 0 0 8px 0;\n  }\n  .BannerCommon .MobileCommonBannerNew,\n  .CurrentIpsSection .CurrentIpsInner .ipsBackImg,\n  .NewsletterSection .NewsletterInner .emailInput,\n  .WrapperContactBackstage .ContactBsSection form,\n  .WrapperOurTeam .BannerCommon .BannerCommonText,\n  .dropdownNewContact {\n    width: 100%;\n  }\n  .TeamHyperLink img,\n  .contactSection .socialIcon img,\n  .dropdownArrowImg {\n    width: 25px;\n  }\n  .BackStageMaharajaMain .BackStageMaharajaMainBottom,\n  .WrapperTemplatePage .TPBottom,\n  .dropdownNewContact {\n    padding: 0;\n  }\n  .dropdownNewContact ul li {\n    max-width: 100%;\n  }\n  .dropdownNewContact ul li img {\n    width: 25px;\n    padding-right: 5px;\n  }\n  .dropdownNewContact ul {\n    display: block;\n    width: 100%;\n  }\n  .ContactBsSection .ContactParaNew input,\n  .ContactBsSection .ContactParaNew select,\n  .WrapperContactBackstage .ContactBsSectionBottom .ContactParaNew {\n    font-size: 20px;\n    line-height: 36px;\n  }\n  .contactSection .socialIcon span {\n    font-weight: 500 !important;\n    font-size: 11px !important;\n    line-height: 14px !important;\n    color: #000 !important;\n  }\n  .contactSection .contactinfoMain {\n    display: flex !important;\n  }\n  .BackStageContactFooter {\n    padding: 60px 15px !important;\n  }\n  .contactSection .contactinfoMain .mainInfo:first-child span {\n    display: inline-block !important;\n  }\n  .contactTopInfo .contactinfoMain .mainInfo span {\n    margin-top: 0 !important;\n  }\n  .BackstageMenuMain .BackstageMenuLi a,\n  .CreditSection p,\n  .ExtraParaIpinside p,\n  .ReadMoreCmn,\n  .StoryInformationBackstageSection .StoryInformationBackstageRight td,\n  .contactSection .contactTopInfo p {\n    font-size: 16px;\n    line-height: 21px;\n  }\n  .BackStageMaharajaMain\n    .BackStageMaharajaMainBottom\n    .BackStageMaharajaLeft\n    h3\n    br,\n  .BackStageMaharajaMain\n    .BackStageMaharajaMainBottom\n    .BackStageMaharajaRight\n    p\n    br,\n  .BannerCommon .BannerCommonImg,\n  .BshyperLinkStoryTitleMain .BSHyperLinkPriviousNextMain a img,\n  .CreditSection p br,\n  .ExtraParaIpinside p br,\n  .GuppyStoriesBackstageSection .GuppyStoriesBackstageSoical h3 br,\n  .ImageBottomInfoSpan br,\n  .MaharajaBannerImg,\n  .WhoWeAreSectionNewBottomCutImg,\n  .WrapperContactBackstage .ContactBsSectionTop p br,\n  .WrapperGuppyIntro p br,\n  .WrapperTemplatePage .WTGBSectionRight img,\n  .WrapperTemplatePage .WhoWeAreSection .WhoWeAreRight p br,\n  .WrapperWhatWeSell .WhoWeAreRight p br,\n  .WrapperWhoWeAre .WTGBSectionRight,\n  .WrapperWhoWeAre\n    .WhoWeAreSectionNewBottom\n    .WTGBSectionLeft\n    .WrapperWhoWeAre\n    .WhoWeAreSectionNewBottom\n    .WTGBSectionRight {\n    display: none;\n  }\n  .ContactTop::before,\n  .bannerSlider .SliderImg,\n  .bannerSlider .bannerSliderBtn {\n    display: none !important;\n  }\n  .contactSection .contactinfoMain .mainInfo .socialIcon {\n    text-align: left !important;\n  }\n  .WrapperNews .TeamDarkBCGroung {\n    padding: 30px 15px;\n    margin-top: 0;\n  }\n  .WrapperNews .BannerCommon {\n    margin-top: 0;\n  }\n  .WrapperNews .BannerCommon .BackBtnBSCommonNew {\n    top: 20px;\n    left: 30px;\n  }\n  .WrapperWhatWeSell .TeamLightBCGroung {\n    padding: 50px 15px 0;\n    background-size: 100% 100%;\n  }\n  .SellProductMain .CurrentIpsSection .CurrentIpsInner p {\n    justify-content: left;\n    text-align: left;\n    font-size: 20px;\n    line-height: 23px;\n    height: auto;\n  }\n  .SellProductMain .CurrentIpsSection .CurrentIpsInner .SellProductPara {\n    padding: 15px 5px;\n  }\n  .StoryInformationBackstageSection .StoryInformationBackstageRight h4 {\n    font-size: 24px;\n    line-height: 31px;\n    margin: 0 auto 30px;\n  }\n  .CreditSection {\n    background-image: url(../../assets/images/BsNewDarkBG.png);\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n  }\n  .BannerCommon,\n  .ExtraParaIpinside {\n    margin-top: -50px;\n  }\n  .BshyperLinkStoryTitleMain {\n    padding: 50px 0;\n  }\n  .BSHyperLinkPriviousNextMain a,\n  .BshyperLinkStoryTitleMain a {\n    font-size: 10px;\n    line-height: 13px;\n  }\n  .BshyperLinkStoryTitleMain h1 {\n    font-size: 32px;\n    line-height: 37px;\n    margin-bottom: 0;\n  }\n  .ImageBottomInfoSpan {\n    font-size: 12px;\n    line-height: 15px;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner {\n    padding: 60px 15px;\n    text-align: center;\n  }\n  .WrapperIpInside .ExtraParaIpinside {\n    padding: 50px 0 20px;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner p {\n    text-align: left;\n  }\n  .WrapperWhatWeDo .WhatWeDoInner a {\n    display: block;\n    margin-bottom: 40px;\n  }\n  .GIMain h1,\n  .WrapperTemplatePage .WhoWeAreSection h1,\n  .WrapperWhoWeAre .WhoWeAreSection .BsH1 {\n    margin-bottom: 0;\n  }\n  .MobileIntroducingImgNew {\n    display: block;\n    width: 100%;\n    margin-top: -50px;\n  }\n  .MobileMaharajaImageNew {\n    display: block;\n    width: 100%;\n    margin-top: -44px;\n  }\n  .BackStageMaharajaMain .MaharajaBannerImg {\n    margin-top: -30px;\n  }\n  .WrapperGuppyIntro,\n  .WrapperTemplatePage {\n    background: #e4f2ff;\n  }\n  .WrapperTemplatePage .WhoWeAreSection {\n    padding: 50px 0 0;\n  }\n  .GIMain p.paraTop {\n    margin: 30px 0;\n  }\n  .GIMain p.paraBottom {\n    margin: 36px 0 40px;\n  }\n  .WhoWeAreRightNew,\n  .WrapperWhoWeAre .WTGBSection .Row {\n    margin-bottom: 40px;\n  }\n  .WhoWeAreSectionNewBottom {\n    padding: 0 0 60px;\n  }\n  .WhoWeAreSectionNewBottom h2 {\n    margin: 20px 0;\n  }\n  .WrapperWhoWeAre .WTGBSection {\n    padding: 30px 0;\n  }\n  .WrapperWhoWeAre .WhoWeAreSection {\n    margin-top: -40px;\n  }\n  .BannerCommon .BackBtnBSCommonNew {\n    width: 36px;\n    top: 90px;\n    left: 20px;\n  }\n  .ReadMoreCmn img {\n    width: 28px;\n  }\n  .BsComBtn {\n    padding: 5px 20px;\n  }\n  .BsH1,\n  .BsH2,\n  .BsH3 {\n    font-size: 32px;\n    line-height: 37px;\n    margin-bottom: 20px;\n  }\n  .BsCommaonP {\n    font-size: 16px;\n    line-height: 22px;\n  }\n  .NewsSection,\n  .WTGBSection {\n    padding: 20px 0;\n  }\n  .WTGBSection .Row {\n    flex-direction: column-reverse;\n  }\n  .WTGBSection .WTGBSectionLeft p,\n  .WhoWeAreSection .WhoWeAreRight p {\n    margin: 16px 0 25px;\n    text-align: left;\n  }\n  .WhoWeAreSection {\n    padding: 50px 0;\n    text-align: center;\n  }\n  .WTGBSection h2 span {\n    font-size: 24px;\n    line-height: 28px;\n    display: block;\n    color: #000;\n  }\n  .BackstageMenuMain .liMainBs:hover:before {\n    background-image: url(../../assets/images/MobileleftHover.png);\n    width: 11px;\n    height: 25px;\n    left: -22px;\n    top: 11px;\n  }\n  .BackstageMenuMain .liMainBs:hover:after {\n    background-image: url(../../assets/images/MobilerightHover.png);\n    width: 13px;\n    height: 25px;\n    right: 190px;\n    top: 11px;\n  }\n  .BackstageMenuMain .BackstageMenuLi {\n    width: 60%;\n    padding: 7px 30px;\n  }\n  .BackstageMenuMain .BackstageMenuSubLi {\n    width: 50%;\n  }\n  .BackstageMenuMain .BAckstageSubmenu {\n    position: initial;\n    margin-left: 30px;\n  }\n  .navheaderBackstage .navheaderBgImg {\n    height: 72px;\n  }\n  .navbarInnerInfo {\n    flex-direction: row-reverse;\n  }\n  .SocialIconMenu {\n    margin-top: 50px;\n  }\n  .BackstageMenuMain .BAckstageSubmenu li a {\n    font-size: 16px;\n    line-height: 20px;\n  }\n  .BackstageMenuMain .liMainBs img {\n    width: 24px;\n    margin-bottom: 5px !important;\n    transition: 1s ease-in-out;\n  }\n  .BackstageMenuMain .liMainBs:hover img.BackstageMenuMainNavHover {\n    transform: rotate(90deg);\n  }\n  .BackstageMenuMain .BackstageMenuBottom p {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  .BackstageMenuMain .BackstageMenuBottom .SocialIconMenu img {\n    width: 34px;\n    height: 34px;\n  }\n  .BsComBtn {\n    font-size: 16px;\n    line-height: 21px;\n    border-image-outset: 6px;\n  }\n  .BsComBtn img {\n    width: 22px;\n  }\n  .NewsletterSection .NewsletterInner h3,\n  .navheaderBackstage .MainHeadingHead {\n    font-size: 32px;\n    line-height: 37px;\n  }\n  .bannerSlider {\n    margin-top: -25px;\n  }\n  .CurrentIpsSection .CurrentIpsInner .currentIpsLogo {\n    width: 40%;\n  }\n  .CurrentIpsSection .CurrentIpsInner .currentIpsNew {\n    width: 60px;\n  }\n  .CurrentIpsSection {\n    margin-top: -20px;\n    background-size: contain;\n    padding: 20px 0 0;\n  }\n  .NewsletterSection {\n    padding: 25px 0;\n  }\n  .NewsletterInner {\n    width: 100%;\n    padding: 32px 20px;\n  }\n  .NewsletterSection .NewsletterInner p {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .NewsSection h2,\n  .NewsSection p.BsCommaonP,\n  .WrapperOurTeam .TeamInnerTextSec p.BsCommaonP {\n    margin-bottom: 20px;\n  }\n  .GuppyStoriesBackstageSection {\n    padding: 50px 0 60px;\n    text-align: center;\n  }\n  .GuppyStoriesBackstageSection .GuppyStoriesBackstageRight p {\n    margin: 16px 0 24px;\n  }\n  .GuppyStoriesBackstageSection .GuppyStoriesBackstageSectionBottom {\n    margin-top: 24px;\n  }\n  .GuppyStoriesBackstageSection .GuppyStoriesBackstageSoical h3 {\n    margin-bottom: 24px;\n    margin-top: 24px;\n  }\n  .GuppyStoriesBackstageSection\n    .GuppyStoriesBackstageSoical\n    .GuppyStoriesBackstageSoicalMain\n    span {\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 24px;\n  }\n  .GuppyStoriesBackstageSection\n    .GuppyStoriesBackstageSoical\n    .GuppyStoriesBackstageSoicalMain\n    a\n    img {\n    width: 150px;\n  }\n  .FooterBackstage {\n    padding-top: 30px;\n  }\n  .WrapperWhoWeAre .WhoWeAreSection p {\n    text-align: center;\n    margin: 16px 0 25px;\n  }\n  .WrapperWhoWeAre .WhoWeAreSectionNewBottom .WhoWeAreSectionNewBottomCutImg {\n    margin-top: -45px;\n  }\n  .WrapperWhoWeAre .WhoWeAreSectionNewBottom {\n    padding-bottom: 90px;\n  }\n  .BsH4 {\n    font-size: 24px;\n    line-height: 31px;\n    margin-bottom: 20px;\n    margin-top: 20px;\n  }\n  .TeamHyperLink {\n    font-size: 16px;\n    line-height: 21px;\n    margin-top: 20px;\n    margin-bottom: 40px;\n    text-align: center;\n  }\n  .TeamDarkBCGroung {\n    padding: 50px 0 60px;\n    margin-top: -90px;\n  }\n  .TeamLightBCGroung {\n    padding: 20px 0 60px;\n    margin-top: -55px;\n    background-size: contain;\n  }\n  .WrapperOurTeam .BannerCommon {\n    padding: 0 30px;\n    height: 315px;\n  }\n  .BackStageMaharajaMain\n    .BackStageMaharajaMainBottom\n    .BackStageMaharajaRightRow,\n  .TeamLightBCGroung .Row {\n    flex-direction: column-reverse;\n  }\n  .BackStageMaharajaMain .BackStageMaharajaMainTop p {\n    font-size: 11px;\n    line-height: 22px;\n    margin-top: 0;\n    padding: 0 15px;\n  }\n  .BackStageMaharajaMain .BackStageMaharajaMainBottom p {\n    font-size: 16px;\n    line-height: 22px;\n    margin: 20px 0;\n  }\n  .BackStageMaharajaMain\n    .BackStageMaharajaMainBottom\n    .BackStageMaharajaLeft\n    h3 {\n    font-size: 19px;\n    line-height: 27px;\n    margin-bottom: 20px;\n  }\n  .BSHyperLinkPriviousNextMain a img {\n    width: 20px;\n  }\n  .BackStageMaharajaMain\n    .BackStageMaharajaMainBottom\n    .BackStageMaharajaRight\n    p {\n    font-size: 11px;\n    line-height: 18px;\n  }\n}\n@media (max-width: 575px) {\n  .BshyperLinkStoryTitleMain {\n    padding: 5px 0 20px;\n  }\n  nav img {\n    width: 25px;\n  }\n  .BackstageMenuMain {\n    padding-top: 40px;\n  }\n  .navheaderBackstage .MainHeadingHead {\n    font-size: 32px;\n    line-height: 37px;\n  }\n  .BackstageMenuMain .liMainBs:hover:before {\n    left: -13px;\n    top: 7px;\n  }\n  .BackstageMenuMain .liMainBs:hover:after {\n    right: 113px;\n    top: 7px;\n  }\n}\n@media (max-width: 400px) {\n  .FooterBackstage .footerMid {\n    padding-left: 20px;\n  }\n}\n.BackStageMaharajaMainBottom .BackStageMaharajaRight img,\n.TeamInnerImgSec .TeamInnercommonImg,\n.WTGBSectionRight img,\n.WhatWeDoInner .TeamInnerImgSec img,\n.WhoWeAreSection .WhoWeAreleft img {\n  width: 100%;\n  height: 500px;\n  border: 7px solid #0d5268;\n  border-radius: 6px;\n  object-fit: cover;\n}\n.GuppyStoriesBackstageLeft img {\n  width: 100%;\n  height: 500px;\n  border-radius: 6px;\n  object-fit: contain;\n}\n.WrapperWhatWeDo .WhatWeDoInner .TeamInnerImgSec img {\n  object-fit: fill;\n}\n.WrapperWhoWeAre .WTGBSection .WTGBSectionRight img {\n  height: auto;\n  object-fit: unset;\n}\n.WrapperGuppyIntro .TeamDarkBCGroung {\n  padding: 120px 0;\n}\n.WrapperMain .WhoWeAreSection .WhoWeAreRight .ReadMoreCmn span {\n  text-align: center;\n  display: inline-block;\n  margin-right: 20px;\n  padding: 0;\n}\n.GuppyStoriesBackstageSection\n  .GuppyStoriesBackstageSectionTop\n  .GuppyStoriesBackstageRight,\n.TeamInnerTextSec,\n.WTGBSectionLeft,\n.WrapperMain .WhoWeAreSection .WhoWeAreRight {\n  padding-left: 40px;\n}\n.WhoWeAreRightNew .IntoductionParanew {\n  width: 70%;\n  margin: 0 auto 50px;\n}\n.WrapperWhatWeDo .IntoductionParanew {\n  width: 72%;\n  margin: 0 auto 50px;\n}\n.WrapperIpInside .CreditSection {\n  background-image: url(../../assets/images/GuppyStoriesBG.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 80px 60px;\n  position: relative;\n}\n.WrapperIpInside .CreditSection p,\n.WrapperIpInside .ExtraParaIpinside p {\n  width: 75%;\n  margin: auto;\n  font-weight: 400;\n  font-size: 21px;\n  line-height: 30px;\n  text-align: center;\n  color: #000;\n}\n.StoryInformationBackstageLeft img {\n  width: 100%;\n  height: 100%;\n}\n.CreditSectionTop .CreditSection {\n  margin-top: -125px;\n}\n.IPInsideFirstMAinPara {\n  padding-top: 60px;\n}\n.WrapperIpInside .StoryInformationBackstageLeft {\n  padding-left: 0;\n}\n.WrapperIpInside .ExtraParaIpinside {\n  margin-top: -75px;\n}\n.WrapperIpInside .StoryInformationBackstageLeft img {\n  height: 860px;\n  object-fit: cover;\n}\n.CopyrightTextNew span {\n  position: absolute;\n  bottom: 15px;\n  left: 15px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 15px;\n  text-align: left;\n}\n@media (min-width: 768px) and (max-width: 1199px) {\n  .BackstageMenuMain .liMainBs:first-child .BAckstageSubmenu {\n    right: 20px;\n  }\n  .BackstageMenuMain .BAckstageSubmenu {\n    right: 56px;\n  }\n}\n.WrapperOurStory .WTGBSection {\n  background-size: 100% 100%;\n  margin-top: -95px;\n  position: relative;\n  padding: 80px 60px;\n}\n.WrapperOurStory .WhoWeAreSection {\n  padding: 90px 60px 160px;\n  background: #b3e8ec;\n}\n.WrapperOurStory .OurStoryExtraParaNew {\n  margin: 80px 0 100px;\n  text-align: center;\n}\n.MainWWANewExtraImg {\n  border: 7px solid #0d5268;\n  border-radius: 6px;\n}\n@media (min-width: 768px) {\n  .SellProductMain .CurrentIpsSection .CurrentIpsInner p {\n    padding: 5px 35px;\n  }\n  .BannerCommon .MobileCommonBannerNew,\n  .MainWWANewExtraImg,\n  .SellProductMain .SharePlusSign,\n  .StoryInformationMobileBottom,\n  .TeamInner .TeamInnerTextSec .mobileteamtitle,\n  .WrapperIpInside .NewGuppyIPStoryPAra .MobileBreakerImg,\n  .WrapperIpInside .TopSectionbreaker1BN .MobileBreakerImg,\n  .WrapperOurTeam .TeamInnerMobileSectionImg {\n    display: none;\n  }\n  .bannerSlider .MobileBannerBackstageImg {\n    display: none !important;\n  }\n  .TeamInner .TeamInnerImgSec p {\n    font-size: 35px;\n    line-height: 40px;\n    font-weight: 700;\n    padding: 25px 0 0;\n  }\n  .TeamInner .Row,\n  .WrapperIpInside .WTGBSection .Row {\n    align-items: flex-start;\n  }\n  .TeamInner .TeamInnerImgSec:nth-child(2n) a,\n  .TeamInner .TeamInnerImgSec:nth-child(2n) p {\n    text-align: right;\n  }\n  .TeamInner .TeamInnerImgSec:nth-child(odd) a,\n  .TeamInner .TeamInnerImgSec:nth-child(odd) p {\n    text-align: left;\n  }\n}\n@media (max-width: 767px) {\n  .WrapperIpInside .ExtraParaIpinside,\n  .WrapperOurTeam .mainRel .TeamLightBCGroung {\n    background-image: url(../../assets/images/mobileTeamLightBg.png);\n  }\n  .StoryInformationDesktopBottom,\n  .TeamInner .TeamInnerTextSec .desktopteamtitle,\n  .WrapperIpInside .NewGuppyIPStoryPAra .desktopBreakerImg,\n  .WrapperIpInside .TopSectionbreaker1BN .desktopBreakerImg,\n  .WrapperIpInside .WTGBSectionRight img,\n  .WrapperIpInside .WTGBSectionRight span,\n  .WrapperOurStory .WTGBSectionRight,\n  .WrapperOurTeam .TeamInnerImgSec {\n    display: none;\n  }\n  .CopyrightTextNewMobile {\n    display: block;\n  }\n  .TopSectionbreaker1BN p {\n    padding: 30px !important;\n  }\n  .WrapperIpInside .StoryInformationBackstageLeft img {\n    height: 100% !important;\n  }\n  .WrapperOurTeam .mainRel .TeamDarkBCGroung {\n    background-image: url(../../assets/images/OurTeamDarkBgBlue.png);\n    margin-top: -40px;\n  }\n  .WrapperOurTeam .globalCreaterNew .TeamInnerTextSec p {\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 10px;\n  }\n  .WrapperOurTeam .TeamInnerMobileSectionImg img {\n    border: 7px solid #0d5268;\n    border-radius: 6px;\n  }\n  .WrapperOurTeam .TeamInner .Row {\n    margin-bottom: 10px;\n  }\n  .WrapperIpInside .CreditSection p,\n  .WrapperIpInside .ExtraParaIpinside p {\n    font-size: 16px;\n    line-height: 20px !important;\n    width: 100%;\n    margin: 10px auto !important;\n  }\n  .WrapperIpInside .ExtraParaIpinside {\n    margin-top: -35px;\n  }\n  .WrapperIpInside .StoryInformationBackstageLeft,\n  .WrapperWhatWeDo .TeamDarkBCGroung .WhatWeDoInner {\n    padding: 0;\n  }\n  .CreditSectionTop .CreditSection {\n    margin-top: -25px;\n  }\n  .BackStageMaharajaMainBottom .BackStageMaharajaRight img,\n  .GuppyStoriesBackstageLeft img,\n  .TeamInnerImgSec .TeamInnercommonImg,\n  .WTGBSectionRight img,\n  .WhatWeDoInner .TeamInnerImgSec img,\n  .WhoWeAreSection .WhoWeAreleft img {\n    height: auto;\n  }\n  .WrapperGuppyIntro .TeamDarkBCGroung {\n    padding: 60px 0 80px;\n  }\n  .WhoWeAreRightNew .IntoductionParanew,\n  .WrapperWhatWeDo .IntoductionParanew {\n    width: 100%;\n  }\n  .GuppyStoriesBackstageSection\n    .GuppyStoriesBackstageSectionTop\n    .GuppyStoriesBackstageRight,\n  .TeamInnerTextSec,\n  .WTGBSectionLeft,\n  .WrapperMain .WhoWeAreSection .WhoWeAreRight {\n    padding-left: 15px;\n  }\n  .WrapperIpInside .CreditSection {\n    padding: 45px 0 60px;\n  }\n  .CurrentIpsSection .CurrentIpsInner {\n    padding: 10px 0;\n  }\n  .GuppyStoriesBackstageImgMobile {\n    margin-top: 35px;\n  }\n  .GuppyStoriesBackstageImgMobile img {\n    margin-bottom: -35px;\n  }\n  .WrapperWhatWeDo .IntoductionParanew {\n    text-align: center;\n  }\n  .WrapperWhatWeDo .TeamDarkBCGroung {\n    margin-top: -63px;\n  }\n  .NewGuppyIPStoryPAra p {\n    line-height: 30px !important;\n    margin: 30px 0 0 !important;\n  }\n  .WrapperOurStory .WTGBSection {\n    background-image: url(../../assets/images/mobileTeamLightBg.png);\n    padding: 80px 0;\n    margin-top: -90px;\n  }\n  .WrapperOurStory .WhoWeAreSection {\n    padding: 40px 0 80px;\n  }\n  .WrapperOurStory .OurStoryExtraParaNew {\n    margin: 40px 0 0;\n    text-align: center;\n  }\n  .WrapperIpInside .storeIconRight img,\n  .WrapperOurStory .WhoWeAreSection .storeIconRight img {\n    width: 142px;\n  }\n  .WrapperOurStory .parabottomtranmedia img {\n    width: 150px;\n    margin: 15px auto;\n  }\n  .WrapperOurStory .paraMidiletranmedia {\n    margin: 20px 0 !important;\n  }\n  .WrapperOurStory .WTGBSectionLeft img,\n  .WrapperOurStory .WTGBSectionLeft p {\n    margin-bottom: 20px;\n  }\n}\n\n.bannerSlider {\n  padding-top: 110px;\n}\n.WrapperIpInside,\n.WrapperOurTeam,\n.WrapperOurStory,\n.WrapperContactBackstage,\n.WrapperWhoWeAre,\n.WrapperWhatWeDo {\n  padding-top: 105px;\n}\n.WrapperIpInside .StoryInformationBackstageSection .Row {\n  align-items: flex-start;\n}\n.WrapperIpInside .StoryInformationBackstageLeft img {\n  height: 580px;\n  object-position: right;\n}\n@media (max-width: 767px) {\n  .bannerSlider {\n    padding-top: 80px;\n  }\n  .WrapperIpInside,\n  .WrapperOurTeam,\n  .WrapperOurStory,\n  .WrapperContactBackstage,\n  .WrapperWhoWeAre,\n  .WrapperWhatWeDo {\n    padding-top: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BSHyperLinkPriviousNextMain": `Backstagelandingpage_BSHyperLinkPriviousNextMain__CjOWO`,
	"BackstageMenuMain": `Backstagelandingpage_BackstageMenuMain__Fhsr6`,
	"BackstageMenuSubLi": `Backstagelandingpage_BackstageMenuSubLi__+JeiS`,
	"TeamHyperLink": `Backstagelandingpage_TeamHyperLink__fZURU`,
	"BsComBtn": `Backstagelandingpage_BsComBtn__IHULv`,
	"BsComYellowBtn": `Backstagelandingpage_BsComYellowBtn__nv6wY`,
	"BsH1": `Backstagelandingpage_BsH1__T6mc9`,
	"BsH2": `Backstagelandingpage_BsH2__pgYpZ`,
	"WrapperIpInside": `Backstagelandingpage_WrapperIpInside__h+nE0`,
	"WTGBSection": `Backstagelandingpage_WTGBSection__kTe6v`,
	"WrapperMain": `Backstagelandingpage_WrapperMain__oLyIf`,
	"WrapperOurTeam": `Backstagelandingpage_WrapperOurTeam__JW5qZ`,
	"Row": `Backstagelandingpage_Row__gfnt4`,
	"BsH3": `Backstagelandingpage_BsH3__KKWUT`,
	"BsH4": `Backstagelandingpage_BsH4__5Dg3m`,
	"DropDownButtonChild": `Backstagelandingpage_DropDownButtonChild__LGQij`,
	"BsCommaonP": `Backstagelandingpage_BsCommaonP__GE0Hn`,
	"BsCommaonPS": `Backstagelandingpage_BsCommaonPS__nOJP0`,
	"BsCommaonPM": `Backstagelandingpage_BsCommaonPM__59mZC`,
	"navheaderBackstage": `Backstagelandingpage_navheaderBackstage__9p2NY`,
	"navheaderBgImg": `Backstagelandingpage_navheaderBgImg__JIePU`,
	"MainHeadingHead": `Backstagelandingpage_MainHeadingHead__Mpbn+`,
	"WrapperContactBackstage": `Backstagelandingpage_WrapperContactBackstage__V-Mv3`,
	"WrapperTemplatePage": `Backstagelandingpage_WrapperTemplatePage__p9CWA`,
	"WrapperWhatWeSell": `Backstagelandingpage_WrapperWhatWeSell__w4S7y`,
	"WrapperWhoWeAre": `Backstagelandingpage_WrapperWhoWeAre__7UPpF`,
	"BackstageMenuLi": `Backstagelandingpage_BackstageMenuLi__SEL2V`,
	"BackstageMenuBottom": `Backstagelandingpage_BackstageMenuBottom__woCpn`,
	"SocialIconMenu": `Backstagelandingpage_SocialIconMenu__8JHy8`,
	"BAckstageSubmenu": `Backstagelandingpage_BAckstageSubmenu__MQ+VB`,
	"liMainBs": `Backstagelandingpage_liMainBs__s7L8T`,
	"BackstageMenuMainNavimg": `Backstagelandingpage_BackstageMenuMainNavimg__SByLy`,
	"BackstageMenuMainNavHover": `Backstagelandingpage_BackstageMenuMainNavHover__Ajz1W`,
	"CopyrightTextNewMobile": `Backstagelandingpage_CopyrightTextNewMobile__Ib3yh`,
	"CurrentIpsSection": `Backstagelandingpage_CurrentIpsSection__6Mqki`,
	"CurrentIpsInner": `Backstagelandingpage_CurrentIpsInner__4tGZe`,
	"currentIpsLogo": `Backstagelandingpage_currentIpsLogo__ofB2v`,
	"currentIpsNew": `Backstagelandingpage_currentIpsNew__lHWGU`,
	"DropDownButtonNew": `Backstagelandingpage_DropDownButtonNew__KqAsa`,
	"MobileIntroducingImgNew": `Backstagelandingpage_MobileIntroducingImgNew__-zkqx`,
	"MobileMaharajaImageNew": `Backstagelandingpage_MobileMaharajaImageNew__PDwYm`,
	"WTGBSectionLeft": `Backstagelandingpage_WTGBSectionLeft__CbXmj`,
	"ImageBottomInfoSpan": `Backstagelandingpage_ImageBottomInfoSpan__qxCA0`,
	"GuppyStoriesBackstageSection": `Backstagelandingpage_GuppyStoriesBackstageSection__D0jY4`,
	"GuppyStoriesBackstageSectionTop": `Backstagelandingpage_GuppyStoriesBackstageSectionTop__wmes2`,
	"navbarInnerInfo": `Backstagelandingpage_navbarInnerInfo__NPMxs`,
	"navheaderBackstageNew": `Backstagelandingpage_navheaderBackstageNew__KJ4Fe`,
	"navheaderMainInner": `Backstagelandingpage_navheaderMainInner__+507B`,
	"StoryInformationBackstageSection": `Backstagelandingpage_StoryInformationBackstageSection__2pK2q`,
	"StoryInformationBackstageRight": `Backstagelandingpage_StoryInformationBackstageRight__M101Z`,
	"WhoWeAreSectionNewBottomCutImg": `Backstagelandingpage_WhoWeAreSectionNewBottomCutImg__aIRJd`,
	"WrapperGuppyIntro": `Backstagelandingpage_WrapperGuppyIntro__Njw19`,
	"TeamDarkBCGroung": `Backstagelandingpage_TeamDarkBCGroung__xTYxT`,
	"bannerSlider": `Backstagelandingpage_bannerSlider__us3k0`,
	"bannerSliderBtn": `Backstagelandingpage_bannerSliderBtn__2KGef`,
	"ReadMoreCmn": `Backstagelandingpage_ReadMoreCmn__tCmlt`,
	"WhoWeAreSection": `Backstagelandingpage_WhoWeAreSection__sBp4Q`,
	"ipsBackImg": `Backstagelandingpage_ipsBackImg__8tOVO`,
	"SeeMoreBtn": `Backstagelandingpage_SeeMoreBtn__E6xir`,
	"NewsletterSection": `Backstagelandingpage_NewsletterSection__QI+5+`,
	"NewsletterInner": `Backstagelandingpage_NewsletterInner__n7WiP`,
	"emailInput": `Backstagelandingpage_emailInput__bbAkb`,
	"NewsSection": `Backstagelandingpage_NewsSection__ntpF-`,
	"WrapperOurStory": `Backstagelandingpage_WrapperOurStory__fDGAl`,
	"GuppyStoriesBackstageRight": `Backstagelandingpage_GuppyStoriesBackstageRight__Jc6tG`,
	"FooterBackstage": `Backstagelandingpage_FooterBackstage__HSsC1`,
	"GuppyStoriesBackstageSectionBottom": `Backstagelandingpage_GuppyStoriesBackstageSectionBottom__jnGjp`,
	"GuppyStoriesBackstageSoical": `Backstagelandingpage_GuppyStoriesBackstageSoical__JuY5p`,
	"GuppyStoriesBackstageSoicalMain": `Backstagelandingpage_GuppyStoriesBackstageSoicalMain__SHP+j`,
	"emailInputBackstage": `Backstagelandingpage_emailInputBackstage__ec4Rd`,
	"BannerCommon": `Backstagelandingpage_BannerCommon__QhnJj`,
	"CopyrightTextNew": `Backstagelandingpage_CopyrightTextNew__zN1j0`,
	"mainRel": `Backstagelandingpage_mainRel__9Egqz`,
	"BackBtnBSCommonNew": `Backstagelandingpage_BackBtnBSCommonNew__B5Ati`,
	"BannerCommonImg": `Backstagelandingpage_BannerCommonImg__HNDYC`,
	"WhoWeAreSectionNewBottom": `Backstagelandingpage_WhoWeAreSectionNewBottom__Jm-NX`,
	"bottomNewWhoWeare": `Backstagelandingpage_bottomNewWhoWeare__Fykbk`,
	"WhoWeAreRightNew": `Backstagelandingpage_WhoWeAreRightNew__NN1nW`,
	"WhoWeAreRight": `Backstagelandingpage_WhoWeAreRight__kG1P5`,
	"TeamLightBCGroung": `Backstagelandingpage_TeamLightBCGroung__JogsD`,
	"WhoWeAreSectionNewTop": `Backstagelandingpage_WhoWeAreSectionNewTop__yFQ2y`,
	"WrapperWhatWeDo": `Backstagelandingpage_WrapperWhatWeDo__ATB7l`,
	"WhatWeDoInner": `Backstagelandingpage_WhatWeDoInner__pB6K4`,
	"BannerCommonText": `Backstagelandingpage_BannerCommonText__Ethep`,
	"ContactBsSection": `Backstagelandingpage_ContactBsSection__jeSI5`,
	"ContactBsSectionTop": `Backstagelandingpage_ContactBsSectionTop__hqInV`,
	"GIMain": `Backstagelandingpage_GIMain__ZvQZM`,
	"WrapperNews": `Backstagelandingpage_WrapperNews__O2k-J`,
	"paraTop": `Backstagelandingpage_paraTop__hu9EY`,
	"paraBottom": `Backstagelandingpage_paraBottom__FUOMo`,
	"WrapperWhatWeDoTop": `Backstagelandingpage_WrapperWhatWeDoTop__wuaMW`,
	"BackStageMaharajaMain": `Backstagelandingpage_BackStageMaharajaMain__P5U2l`,
	"BackStageMaharajaMainBottom": `Backstagelandingpage_BackStageMaharajaMainBottom__C5dpE`,
	"TPBottom": `Backstagelandingpage_TPBottom__VuTE3`,
	"MaharajaBannerImg": `Backstagelandingpage_MaharajaBannerImg__6LkA-`,
	"BackStageMaharajaMainTop": `Backstagelandingpage_BackStageMaharajaMainTop__s99xL`,
	"BackStageMaharajaLeft": `Backstagelandingpage_BackStageMaharajaLeft__EQbuW`,
	"BackStageMaharajaRight": `Backstagelandingpage_BackStageMaharajaRight__R6vnE`,
	"footerMid": `Backstagelandingpage_footerMid__LJX7J`,
	"BshyperLinkStoryTitleMain": `Backstagelandingpage_BshyperLinkStoryTitleMain__PNTnz`,
	"CreditSection": `Backstagelandingpage_CreditSection__RQ6lu`,
	"ExtraParaIpinside": `Backstagelandingpage_ExtraParaIpinside__mBhvY`,
	"BSHyperLinkPriviousNextWrapper": `Backstagelandingpage_BSHyperLinkPriviousNextWrapper__RTHzq`,
	"SellProductMain": `Backstagelandingpage_SellProductMain__kXQS6`,
	"SellProductPara": `Backstagelandingpage_SellProductPara__+ONaV`,
	"SharePlusSign": `Backstagelandingpage_SharePlusSign__YpVT0`,
	"LatestNewsSection": `Backstagelandingpage_LatestNewsSection__CrsGU`,
	"TeamInnerTextSec": `Backstagelandingpage_TeamInnerTextSec__Ytbxp`,
	"ContactParaNew": `Backstagelandingpage_ContactParaNew__mfcvy`,
	"ContactApprovalBox": `Backstagelandingpage_ContactApprovalBox__ybfzi`,
	"TextNameInput": `Backstagelandingpage_TextNameInput__5Z47d`,
	"DropDown": `Backstagelandingpage_DropDown__l3CPf`,
	"EmailUserInput": `Backstagelandingpage_EmailUserInput__kYSgA`,
	"TextCommentInput": `Backstagelandingpage_TextCommentInput__jD5cc`,
	"DropDownButtonParent": `Backstagelandingpage_DropDownButtonParent__MOb1k`,
	"dropdownNewContact": `Backstagelandingpage_dropdownNewContact__-UtAb`,
	"ContactBsSectionBottom": `Backstagelandingpage_ContactBsSectionBottom__m7wzK`,
	"dropdownArrowImg": `Backstagelandingpage_dropdownArrowImg__WwpF4`,
	"SuccessMessage": `Backstagelandingpage_SuccessMessage__LhB+b`,
	"DropDownButtonValue": `Backstagelandingpage_DropDownButtonValue__wgvX2`,
	"copyrightTextNew": `Backstagelandingpage_copyrightTextNew__weF7i`,
	"OurTeamHederTop": `Backstagelandingpage_OurTeamHederTop__JoHdl`,
	"TeamInner": `Backstagelandingpage_TeamInner__E+B0e`,
	"NumberInput": `Backstagelandingpage_NumberInput__2i8YM`,
	"TeamInnerImgSec": `Backstagelandingpage_TeamInnerImgSec__mdNDf`,
	"MobileCommonBannerNew": `Backstagelandingpage_MobileCommonBannerNew__tr8w0`,
	"contactSection": `Backstagelandingpage_contactSection__PnW0L`,
	"socialIcon": `Backstagelandingpage_socialIcon__i-sVT`,
	"contactinfoMain": `Backstagelandingpage_contactinfoMain__9aeNB`,
	"BackStageContactFooter": `Backstagelandingpage_BackStageContactFooter__sHJHg`,
	"mainInfo": `Backstagelandingpage_mainInfo__kxrrh`,
	"contactTopInfo": `Backstagelandingpage_contactTopInfo__83I2e`,
	"WTGBSectionRight": `Backstagelandingpage_WTGBSectionRight__Gg6VG`,
	"ContactTop": `Backstagelandingpage_ContactTop__-w1Bj`,
	"SliderImg": `Backstagelandingpage_SliderImg__TPJC9`,
	"BackStageMaharajaRightRow": `Backstagelandingpage_BackStageMaharajaRightRow__+91EL`,
	"TeamInnercommonImg": `Backstagelandingpage_TeamInnercommonImg__1gnOS`,
	"WhoWeAreleft": `Backstagelandingpage_WhoWeAreleft__tSORb`,
	"GuppyStoriesBackstageLeft": `Backstagelandingpage_GuppyStoriesBackstageLeft__0ydND`,
	"IntoductionParanew": `Backstagelandingpage_IntoductionParanew__FAIdO`,
	"StoryInformationBackstageLeft": `Backstagelandingpage_StoryInformationBackstageLeft__VsqSq`,
	"CreditSectionTop": `Backstagelandingpage_CreditSectionTop__yqspF`,
	"IPInsideFirstMAinPara": `Backstagelandingpage_IPInsideFirstMAinPara__H1494`,
	"OurStoryExtraParaNew": `Backstagelandingpage_OurStoryExtraParaNew__qxch2`,
	"MainWWANewExtraImg": `Backstagelandingpage_MainWWANewExtraImg__ygQ07`,
	"StoryInformationMobileBottom": `Backstagelandingpage_StoryInformationMobileBottom__qIpKa`,
	"mobileteamtitle": `Backstagelandingpage_mobileteamtitle__EjNcV`,
	"NewGuppyIPStoryPAra": `Backstagelandingpage_NewGuppyIPStoryPAra__yHRIy`,
	"MobileBreakerImg": `Backstagelandingpage_MobileBreakerImg__-L7Hh`,
	"TopSectionbreaker1BN": `Backstagelandingpage_TopSectionbreaker1BN__8nGyk`,
	"TeamInnerMobileSectionImg": `Backstagelandingpage_TeamInnerMobileSectionImg__OTLsc`,
	"MobileBannerBackstageImg": `Backstagelandingpage_MobileBannerBackstageImg__HT2SP`,
	"StoryInformationDesktopBottom": `Backstagelandingpage_StoryInformationDesktopBottom__A7ixd`,
	"desktopteamtitle": `Backstagelandingpage_desktopteamtitle__DV1kL`,
	"desktopBreakerImg": `Backstagelandingpage_desktopBreakerImg__PVpny`,
	"globalCreaterNew": `Backstagelandingpage_globalCreaterNew__F3wLH`,
	"GuppyStoriesBackstageImgMobile": `Backstagelandingpage_GuppyStoriesBackstageImgMobile__aZqK6`,
	"storeIconRight": `Backstagelandingpage_storeIconRight__bAHYB`,
	"parabottomtranmedia": `Backstagelandingpage_parabottomtranmedia__nUJl8`,
	"paraMidiletranmedia": `Backstagelandingpage_paraMidiletranmedia__NHGWz`
};
export default ___CSS_LOADER_EXPORT___;
